import HrcLogo from "../../assets/images/logos/hrc.png";
// import ArrowRightIcon from '../../assets/images/website-logos/vuesax-linear-arrow-right.svg'

export const Logo = ({ size, br }) => {
  return (
    <img
      src={HrcLogo}
      height={size}
      width={size}
      alt="HRC"
      style={{ borderRadius: br }}
    />
  );
};

export const DownloadIcons = ({ fill = "none", stroke = "#85a195" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        id="vuesax_linear_receive-square"
        data-name="vuesax/linear/receive-square"
        transform="translate(-748 -380)"
      >
        <g id="receive-square">
          <path
            id="Vector"
            d="M7,20h6c5,0,7-2,7-7V7c0-5-2-7-7-7H7C2,0,0,2,0,7v6C0,18,2,20,7,20Z"
            transform="translate(750 382)"
            fill={fill}
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <g id="Group">
            <g id="Group-2" data-name="Group">
              <path
                id="Vector-2"
                data-name="Vector"
                d="M0,0,3,3,6,0"
                transform="translate(757 391.51)"
                fill={fill}
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <path
                id="Vector-3"
                data-name="Vector"
                d="M0,8V0"
                transform="translate(760 386.51)"
                fill={fill}
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
            </g>
            <path
              id="Vector-4"
              data-name="Vector"
              d="M0,0A18.949,18.949,0,0,0,12,0"
              transform="translate(754 396.51)"
              fill={fill}
              stroke={stroke}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </g>
          <path
            id="Vector-5"
            data-name="Vector"
            d="M0,0H24V24H0Z"
            transform="translate(748 380)"
            fill={fill}
            opacity="0"
          />
        </g>
      </g>
    </svg>
  );
};

export const RenewIcons = ({
  fill = "none",
  stroke = "#fff",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="programming-arrows" transform="translate(-236 -252)">
        <path
          id="Vector"
          d="M7.5,11.5V2a2.006,2.006,0,0,0-2-2H0"
          transform="translate(247.5 256.5)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M3,0,0,2.5,3,5"
          transform="translate(247 254)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M6,3A3,3,0,1,1,3,0,3,3,0,0,1,6,3Z"
          transform="translate(252 268)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0V9.5a2.006,2.006,0,0,0,2,2H7.5"
          transform="translate(241 260)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,5,3,2.5,0,0"
          transform="translate(246 269)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M6,3A3,3,0,1,1,3,0,3,3,0,0,1,6,3Z"
          transform="translate(238 254)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-7"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(236 252)"
          fill={fill}
          opacity="0"
        />
      </g>
    </svg>
  );
};

export const WaveIcons = ({
  fill = "none",
  stroke = "#fff",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        id="Path_71085"
        data-name="Path 71085"
        d="M551.11,546.59a4.788,4.788,0,0,1-2.562-.72,20.118,20.118,0,0,1-2.466-1.875l-.41-.346c-.39-.327-.787-.657-1.172-.976-1.361-1.13-2.767-2.3-4.089-3.513a3.411,3.411,0,0,1-.645-.758c-.471-.781-.455-1.089.082-1.572a1.075,1.075,0,0,1,.7-.2,1.837,1.837,0,0,1,.953.257,25.267,25.267,0,0,1,2.065,1.672c.63.54,1.224,1.05,1.646,1.367a.21.21,0,0,0,.127.043h0a.21.21,0,0,0,.185-.112.18.18,0,0,0-.024-.2c-.635-.768-2.2-2.292-2.941-2.99-.341-.323-.691-.649-1.029-.965-.614-.573-1.248-1.166-1.86-1.758-.467-.452-.946-.993-.707-1.682a1.117,1.117,0,0,1,1.12-.8,2.033,2.033,0,0,1,1.216.453,20.549,20.549,0,0,1,1.931,1.8c.226.23.46.468.694.7.143.14.327.327.541.543a26.392,26.392,0,0,0,2.186,2.065.229.229,0,0,0,.139.047.233.233,0,0,0,.2-.113.2.2,0,0,0-.009-.216,6.921,6.921,0,0,0-.795-.913c-.151-.154-.293-.3-.4-.43-.476-.559-.988-1.1-1.483-1.629-.44-.467-.894-.95-1.321-1.441-.184-.211-.448-.48-.753-.791a10.679,10.679,0,0,1-1.889-2.261,1.079,1.079,0,0,1,.409-1.377,1.357,1.357,0,0,1,.761-.241,1.6,1.6,0,0,1,.88.289,5.875,5.875,0,0,1,1.171,1.12c.114.131.231.266.351.4,1.236,1.344,3.707,3.986,4.649,4.977a.18.18,0,0,0,.132.057.188.188,0,0,0,.159-.089.158.158,0,0,0-.005-.169c-.45-.694-1.529-2.11-3.121-4.094l-.218-.271a14.313,14.313,0,0,1-1.25-1.7.9.9,0,0,1,0-.845,1.34,1.34,0,0,1,.975-.726,1.234,1.234,0,0,1,.208-.018,1.323,1.323,0,0,1,.73.231,11.427,11.427,0,0,1,1.606,1.74c.432.521.878,1.06,1.291,1.5.236.251.777.918,1.35,1.624.744.917,1.587,1.956,1.961,2.33a1.307,1.307,0,0,0,1.435.38,1.1,1.1,0,0,0,.791-1.129,3.633,3.633,0,0,1,.994-2.695,3.254,3.254,0,0,1,2.052-.705,1.539,1.539,0,0,1,.69.132.938.938,0,0,1,.427,1.359c-.084.164-.172.328-.257.488a6.924,6.924,0,0,0-.958,2.593,6.41,6.41,0,0,0,.1,1.56c.027.183.055.372.077.559.047.412.117.829.185,1.233a9.56,9.56,0,0,1,.187,2.953v.007a5.523,5.523,0,0,1-1.9,3.663,8.574,8.574,0,0,1-3.418,1.943A6.493,6.493,0,0,1,551.11,546.59Z"
        transform="translate(-538.899 -526.59)"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export const HomeIcons = ({ fill = "none", stroke = "#FFFFFF" }) => {
  return (
    <svg
      id="vuesax_linear_gallery"
      data-name="vuesax/linear/gallery"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <g id="gallery" transform="translate(-364 -252)">
        <g
          id="vuesax_linear_home-2"
          data-name="vuesax/linear/home-2"
          transform="translate(-256 64)"
        >
          <g id="home-2">
            <path
              id="Vector"
              d="M7.02.823l-5.39,4.2A4.759,4.759,0,0,0,0,8.343v7.41a4.225,4.225,0,0,0,4.21,4.22H15.79A4.223,4.223,0,0,0,20,15.763V8.483a4.723,4.723,0,0,0-1.8-3.45L12.02.7A4.487,4.487,0,0,0,7.02.823Z"
              transform="translate(622 190.017)"
              fill={fill}
              stroke={stroke}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Vector-2"
              data-name="Vector"
              d="M0,3V0"
              transform="translate(632 202.99)"
              fill={fill}
              stroke={stroke}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Vector-3"
              data-name="Vector"
              d="M0,0H24V24H0Z"
              transform="translate(620 188)"
              fill={fill}
              opacity="0"
            />
          </g>
        </g>
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(364 252)"
          fill={fill}
          opacity="0"
        />
      </g>
    </svg>
  );
};

export const ArrowRightIcons = ({
  fill = "#1d3a5f",
  stroke = "#fff",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      id="vuesax_linear_arrow-right"
      data-name="vuesax/linear/arrow-right"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="arrow-right">
        <path
          id="Vector"
          d="M0,0,6.07,6.07,0,12.14"
          transform="translate(14.43 5.93)"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0H16.83"
          transform="translate(3.5 12)"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(24 24) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
};

export const ArrowLeftIcons = ({
  fill = "none",
  stroke = "rgba(18,18,18,0.62)",
  width = "18.5",
  height = "14.261",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18.5 14.261"
    >
      <g
        id="Group_54991"
        data-name="Group 54991"
        transform="translate(-686.75 -192.869)"
      >
        <path
          id="Vector"
          d="M6.07,0,0,6.07l6.07,6.07"
          transform="translate(687.5 193.93)"
          fill="none"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M16.83,0H0"
          transform="translate(687.67 200)"
          fill="none"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export const NodataIcons = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_29380"
            data-name="Rectangle 29380"
            width="80"
            height="80"
            transform="translate(2906 -1182)"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g
        id="Mask_Group_2630"
        data-name="Mask Group 2630"
        transform="translate(-2906 1182)"
        clipPath="url(#clip-path)"
      >
        <g id="Group_53344" data-name="Group 53344">
          <path
            id="Path_109168"
            data-name="Path 109168"
            d="M29.07,0A29.07,29.07,0,1,1,0,29.07,29.07,29.07,0,0,1,29.07,0Z"
            transform="translate(2917 -1171)"
            fill="#f6f6f6"
          />
          <path
            id="Path_109169"
            data-name="Path 109169"
            d="M3.735,0A3.735,3.735,0,1,1,0,3.735,3.735,3.735,0,0,1,3.735,0Z"
            transform="translate(2912.5 -1165.174)"
            fill="#c0c2c2"
          />
          <path
            id="Path_109170"
            data-name="Path 109170"
            d="M2.948,0A2.948,2.948,0,1,1,0,2.948,2.948,2.948,0,0,1,2.948,0Z"
            transform="translate(2917.088 -1171.07)"
            fill="#c0c2c2"
          />
          <circle
            id="Ellipse_4274"
            data-name="Ellipse 4274"
            cx="3"
            cy="3"
            r="3"
            transform="translate(2966.5 -1119.07)"
            fill="#c0c2c2"
          />
          <circle
            id="Ellipse_4275"
            data-name="Ellipse 4275"
            cx="4"
            cy="4"
            r="4"
            transform="translate(2971.5 -1127.07)"
            fill="#c0c2c2"
          />
          <g
            id="vuesax_bulk_transaction-minus"
            data-name="vuesax/bulk/transaction-minus"
            transform="translate(2626 -1414)"
          >
            <g id="transaction-minus" transform="translate(300 252)">
              <path
                id="Vector"
                d="M0,0H40.154V40.154H0Z"
                fill="none"
                opacity="0"
              />
              <path
                id="Vector-2"
                data-name="Vector"
                d="M5.568,30a3.045,3.045,0,0,1,4.794.254L12.1,32.546a3.01,3.01,0,0,0,5.035,0l1.736-2.288A3.045,3.045,0,0,1,23.663,30c3.059,3.221,5.551,2.153,5.551-2.356V8.543C29.213,1.712,27.6,0,21.1,0H8.111C1.615,0,0,1.712,0,8.543V27.63C.017,32.156,2.526,33.207,5.568,30Z"
                transform="translate(5.455 3.126)"
                fill="#e1e2e2"
              />
              <g id="Group" transform="translate(14.607 15.544)">
                <path
                  id="Vector-3"
                  data-name="Vector"
                  d="M9.769,2.345h-8.6A1.181,1.181,0,0,1,0,1.172,1.181,1.181,0,0,1,1.172,0h8.6a1.181,1.181,0,0,1,1.172,1.172A1.181,1.181,0,0,1,9.769,2.345Z"
                  fill="#127a3e"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MActionIcons = ({ fill }) => {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.9994 17.3334C33.2216 17.3334 32.5688 17.5973 32.041 18.1251C31.5132 18.6529 31.2494 19.3056 31.2494 20.0834C31.2494 20.8612 31.5132 21.514 32.041 22.0418C32.5688 22.5695 33.2216 22.8334 33.9994 22.8334C34.7771 22.8334 35.4299 22.5695 35.9577 22.0418C36.4855 21.514 36.7494 20.8612 36.7494 20.0834C36.7494 19.3056 36.4855 18.6529 35.9577 18.1251C35.4299 17.5973 34.7771 17.3334 33.9994 17.3334ZM36.2494 30.0834H31.2494V51.1668H36.2494V30.0834ZM33.9994 0.666748C38.5549 0.666748 42.8605 1.54175 46.916 3.29175C50.9716 5.04175 54.5132 7.43064 57.541 10.4584C60.5688 13.4862 62.9577 17.0279 64.7077 21.0834C66.4577 25.139 67.3327 29.4723 67.3327 34.0834C67.3327 38.639 66.4577 42.9445 64.7077 47.0001C62.9577 51.0556 60.5688 54.5834 57.541 57.5834C54.5132 60.5834 50.9716 62.9584 46.916 64.7084C42.8605 66.4584 38.5271 67.3334 33.916 67.3334C29.3605 67.3334 25.0549 66.4584 20.9994 64.7084C16.9438 62.9584 13.416 60.5834 10.416 57.5834C7.41602 54.5834 5.04102 51.0556 3.29102 47.0001C1.54102 42.9445 0.666016 38.6112 0.666016 34.0001C0.666016 29.4445 1.54102 25.139 3.29102 21.0834C5.04102 17.0279 7.41602 13.4862 10.416 10.4584C13.416 7.43064 16.9438 5.04175 20.9994 3.29175C25.0549 1.54175 29.3882 0.666748 33.9994 0.666748Z"
        fill={fill}
      />
    </svg>
  );
};

export const SuccessIcons = ({ fill }) => {
  return (
    <svg
      id="vuesax_bold_tick-circle"
      data-name="vuesax/bold/tick-circle"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="tick-circle">
        <path
          id="Vector"
          d="M10,0A10,10,0,1,0,20,10,10.016,10.016,0,0,0,10,0Zm4.78,7.7L9.11,13.37a.748.748,0,0,1-1.06,0L5.22,10.54A.75.75,0,1,1,6.28,9.48l2.3,2.3,5.14-5.14A.75.75,0,0,1,14.78,7.7Z"
          transform="translate(2 2)"
          fill={fill}
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(24 24) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
};

export const ChatIcons = ({
  fill = "none",
  stroke = "#292D32",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 10.5H15.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 18.43H11L15.45 21.39C16.11 21.83 17 21.36 17 20.56V18.43C20 18.43 22 16.43 22 13.43V7.42999C22 4.42999 20 2.42999 17 2.42999H7C4 2.42999 2 4.42999 2 7.42999V13.43C2 16.43 4 18.43 7 18.43Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotificationIcons = ({
  fill = "#283745",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99998 1C8.99998 0.734783 8.89462 0.48043 8.70709 0.292893C8.51955 0.105357 8.2652 0 7.99998 0C7.73476 0 7.48041 0.105357 7.29287 0.292893C7.10534 0.48043 6.99998 0.734783 6.99998 1V1.75H6.44298C5.37101 1.74993 4.33931 2.15839 3.5579 2.89224C2.7765 3.62608 2.30414 4.63014 2.23698 5.7L2.01598 9.234C1.93171 10.5814 1.47928 11.8799 0.707981 12.988C0.548614 13.2171 0.451238 13.4835 0.425324 13.7613C0.399409 14.0392 0.445837 14.319 0.560093 14.5736C0.67435 14.8281 0.852545 15.0488 1.07735 15.2141C1.30215 15.3795 1.56591 15.4838 1.84298 15.517L5.24998 15.925V17C5.24998 17.7293 5.53971 18.4288 6.05544 18.9445C6.57116 19.4603 7.27064 19.75 7.99998 19.75C8.72933 19.75 9.4288 19.4603 9.94452 18.9445C10.4602 18.4288 10.75 17.7293 10.75 17V15.925L14.157 15.516C14.4338 15.4826 14.6973 15.3781 14.9218 15.2128C15.1463 15.0475 15.3243 14.8269 15.4384 14.5725C15.5525 14.3181 15.5989 14.0385 15.5731 13.7608C15.5473 13.4832 15.4501 13.217 15.291 12.988C14.5201 11.8798 14.068 10.5813 13.984 9.234L13.763 5.701C13.6961 4.63096 13.2238 3.62665 12.4424 2.8926C11.661 2.15855 10.6291 1.74995 9.55698 1.75H8.99998V1ZM6.74998 17C6.74998 17.3315 6.88168 17.6495 7.1161 17.8839C7.35052 18.1183 7.66846 18.25 7.99998 18.25C8.3315 18.25 8.64944 18.1183 8.88386 17.8839C9.11829 17.6495 9.24998 17.3315 9.24998 17V16.25H6.74998V17Z"
        fill={fill}
      />
    </svg>
  );
};

export const TcIcons = ({ fill = "none", stroke = "#89A594" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 7.09996V3.31663C18.3333 2.14163 17.8 1.66663 16.475 1.66663H13.1083C11.7833 1.66663 11.25 2.14163 11.25 3.31663V7.09163C11.25 8.27496 11.7833 8.74163 13.1083 8.74163H16.475C17.8 8.74996 18.3333 8.27496 18.3333 7.09996Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 16.475V13.1083C18.3333 11.7833 17.8 11.25 16.475 11.25H13.1083C11.7833 11.25 11.25 11.7833 11.25 13.1083V16.475C11.25 17.8 11.7833 18.3333 13.1083 18.3333H16.475C17.8 18.3333 18.3333 17.8 18.3333 16.475Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75008 7.09996V3.31663C8.75008 2.14163 8.21675 1.66663 6.89175 1.66663H3.52508C2.20008 1.66663 1.66675 2.14163 1.66675 3.31663V7.09163C1.66675 8.27496 2.20008 8.74163 3.52508 8.74163H6.89175C8.21675 8.74996 8.75008 8.27496 8.75008 7.09996Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75008 16.475V13.1083C8.75008 11.7833 8.21675 11.25 6.89175 11.25H3.52508C2.20008 11.25 1.66675 11.7833 1.66675 13.1083V16.475C1.66675 17.8 2.20008 18.3333 3.52508 18.3333H6.89175C8.21675 18.3333 8.75008 17.8 8.75008 16.475Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MyToolIcons = ({
  fill = "#283745",
  stroke = "none",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.20605 2.63109C5.40484 2.54224 4.59626 2.54224 3.79505 2.63109C3.50177 2.66367 3.2281 2.7944 3.01844 3.00206C2.80878 3.20972 2.67544 3.48213 2.64005 3.77509C2.54495 4.58832 2.54495 5.40986 2.64005 6.22309C2.71005 6.82909 3.19605 7.30009 3.79505 7.36709C4.58905 7.45709 5.41105 7.45709 6.20505 7.36709C6.49834 7.3345 6.77201 7.20377 6.98166 6.99611C7.19132 6.78845 7.32466 6.51605 7.36005 6.22309C7.45513 5.40986 7.45513 4.58832 7.36005 3.77509C7.3247 3.48228 7.19151 3.20999 6.98205 3.00235C6.7726 2.79471 6.49916 2.66388 6.20605 2.63109Z"
        fill={fill}
        stroke={stroke}
      />
      <path
        d="M13.2061 2.63114C12.4045 2.54222 11.5956 2.54222 10.7941 2.63114C10.5009 2.66394 10.2275 2.79476 10.018 3.0024C9.80859 3.21004 9.6754 3.48233 9.64005 3.77514C9.54495 4.58837 9.54495 5.40991 9.64005 6.22314C9.71005 6.82914 10.1961 7.30014 10.7941 7.36714C11.5891 7.45714 12.4111 7.45714 13.2061 7.36714C13.4992 7.33434 13.7726 7.20352 13.9821 6.99588C14.1915 6.78824 14.3247 6.51595 14.3601 6.22314C14.455 5.40991 14.455 4.58838 14.3601 3.77514C14.3247 3.48233 14.1915 3.21004 13.9821 3.0024C13.7726 2.79476 13.4992 2.66394 13.2061 2.63114Z"
        fill={fill}
        stroke={stroke}
      />
      <path
        d="M20.206 2.63114C19.4045 2.54222 18.5956 2.54222 17.794 2.63114C17.5009 2.66394 17.2275 2.79476 17.018 3.0024C16.8086 3.21004 16.6754 3.48233 16.64 3.77514C16.545 4.58837 16.545 5.40991 16.64 6.22314C16.71 6.82914 17.196 7.30014 17.794 7.36714C18.59 7.45714 19.411 7.45714 20.206 7.36714C20.4991 7.33434 20.7726 7.20352 20.982 6.99588C21.1915 6.78824 21.3247 6.51595 21.36 6.22314C21.455 5.40991 21.455 4.58838 21.36 3.77514C21.3247 3.48233 21.1915 3.21004 20.982 3.0024C20.7726 2.79476 20.4991 2.66394 20.206 2.63114Z"
        fill={fill}
        stroke={stroke}
      />
      <path
        d="M6.20606 9.63109C5.40485 9.54224 4.59627 9.54224 3.79506 9.63109C3.50177 9.66367 3.2281 9.7944 3.01845 10.0021C2.80879 10.2097 2.67545 10.4821 2.64006 10.7751C2.54495 11.5883 2.54495 12.4099 2.64006 13.2231C2.71006 13.8291 3.19606 14.3001 3.79506 14.3671C4.58906 14.4571 5.41106 14.4571 6.20506 14.3671C6.49834 14.3345 6.77201 14.2038 6.98167 13.9961C7.19133 13.7885 7.32467 13.516 7.36006 13.2231C7.45505 12.4099 7.45505 11.5883 7.36006 10.7751C7.32471 10.4823 7.19152 10.21 6.98206 10.0023C6.7726 9.79471 6.49916 9.66388 6.20606 9.63109Z"
        fill={fill}
        stroke={stroke}
      />
      <path
        d="M13.2061 9.63114C12.4045 9.54222 11.5956 9.54222 10.7941 9.63114C10.501 9.66394 10.2275 9.79476 10.0181 10.0024C9.8086 10.21 9.67541 10.4823 9.64006 10.7751C9.54495 11.5884 9.54495 12.4099 9.64006 13.2231C9.71006 13.8291 10.1961 14.3001 10.7941 14.3671C11.5891 14.4571 12.4111 14.4571 13.2061 14.3671C13.4992 14.3343 13.7726 14.2035 13.9821 13.9959C14.1915 13.7882 14.3247 13.516 14.3601 13.2231C14.4551 12.4099 14.4551 11.5884 14.3601 10.7751C14.3247 10.4823 14.1915 10.21 13.9821 10.0024C13.7726 9.79476 13.4992 9.66394 13.2061 9.63114Z"
        fill={fill}
        stroke={stroke}
      />
      <path
        d="M20.206 9.63114C19.4045 9.54222 18.5956 9.54222 17.794 9.63114C17.5009 9.66394 17.2275 9.79476 17.018 10.0024C16.8086 10.21 16.6754 10.4823 16.64 10.7751C16.545 11.5884 16.545 12.4099 16.64 13.2231C16.71 13.8291 17.196 14.3001 17.794 14.3671C18.59 14.4571 19.411 14.4571 20.206 14.3671C20.4991 14.3343 20.7726 14.2035 20.982 13.9959C21.1915 13.7882 21.3247 13.516 21.36 13.2231C21.4551 12.4099 21.4551 11.5884 21.36 10.7751C21.3247 10.4823 21.1915 10.21 20.982 10.0024C20.7726 9.79476 20.4991 9.66394 20.206 9.63114Z"
        fill={fill}
        stroke={stroke}
      />
      <path
        d="M6.20606 16.6311C5.40485 16.5422 4.59627 16.5422 3.79506 16.6311C3.50177 16.6637 3.2281 16.7944 3.01845 17.0021C2.80879 17.2098 2.67545 17.4822 2.64006 17.7751C2.54495 18.5884 2.54495 19.4099 2.64006 20.2231C2.71006 20.8291 3.19606 21.3001 3.79506 21.3671C4.58906 21.4571 5.41106 21.4571 6.20506 21.3671C6.49834 21.3345 6.77201 21.2038 6.98167 20.9961C7.19133 20.7885 7.32467 20.5161 7.36006 20.2231C7.45505 19.4099 7.45505 18.5884 7.36006 17.7751C7.32471 17.4823 7.19152 17.21 6.98206 17.0024C6.7726 16.7947 6.49916 16.6639 6.20606 16.6311Z"
        fill={fill}
        stroke={stroke}
      />
      <path
        d="M13.2061 16.6312C12.4045 16.5422 11.5956 16.5422 10.7941 16.6312C10.501 16.664 10.2275 16.7948 10.0181 17.0024C9.8086 17.2101 9.67541 17.4824 9.64006 17.7752C9.54495 18.5884 9.54495 19.41 9.64006 20.2232C9.71006 20.8292 10.1961 21.3002 10.7941 21.3672C11.5891 21.4572 12.4111 21.4572 13.2061 21.3672C13.4992 21.3344 13.7726 21.2036 13.9821 20.9959C14.1915 20.7883 14.3247 20.516 14.3601 20.2232C14.4551 19.4099 14.4551 18.5884 14.3601 17.7752C14.3247 17.4824 14.1915 17.2101 13.9821 17.0024C13.7726 16.7948 13.4992 16.664 13.2061 16.6312Z"
        fill={fill}
        stroke={stroke}
      />
      <path
        d="M20.206 16.6312C19.4045 16.5422 18.5956 16.5422 17.794 16.6312C17.5009 16.664 17.2275 16.7948 17.018 17.0024C16.8086 17.2101 16.6754 17.4824 16.64 17.7752C16.545 18.5884 16.545 19.4099 16.64 20.2232C16.71 20.8292 17.196 21.3002 17.794 21.3672C18.59 21.4572 19.411 21.4572 20.206 21.3672C20.4991 21.3344 20.7726 21.2036 20.982 20.9959C21.1915 20.7883 21.3247 20.516 21.36 20.2232C21.4551 19.4099 21.4551 18.5884 21.36 17.7752C21.3247 17.4824 21.1915 17.2101 20.982 17.0024C20.7726 16.7948 20.4991 16.664 20.206 16.6312Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export const ReferUserIcons = ({ fill, stroke = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <g id="profile-2user" transform="translate(-172 -252)">
        <path
          id="Vector"
          d="M4.6,8.87a1.818,1.818,0,0,0-.33,0,4.445,4.445,0,1,1,.33,0Z"
          transform="translate(176.56 254)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M.13,0a3.5,3.5,0,0,1,3.5,3.5A3.5,3.5,0,0,1,.26,7,1.129,1.129,0,0,0,0,7"
          transform="translate(188.28 256)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M1.815,1.373c-2.42,1.62-2.42,4.26,0,5.87a9.766,9.766,0,0,0,10.01,0c2.42-1.62,2.42-4.26,0-5.87A9.812,9.812,0,0,0,1.815,1.373Z"
          transform="translate(174.345 265.188)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,6a4.837,4.837,0,0,0,1.96-.87,2.533,2.533,0,0,0,0-4.27A4.973,4.973,0,0,0,.03,0"
          transform="translate(190.34 266)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(196 276) rotate(180)"
          fill={fill}
          opacity="0"
        />
      </g>
    </svg>
  );
};

export const SupportIcons = ({
  fill = "#89A594",
  width = "20",
  height = "20",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2.125C6.29917 2.125 4.20333 3.81667 3.84583 5.875H5.66667C5.83243 5.875 5.9914 5.94085 6.10861 6.05806C6.22582 6.17527 6.29167 6.33424 6.29167 6.5V12.3333C6.29167 12.4991 6.22582 12.6581 6.10861 12.7753C5.9914 12.8925 5.83243 12.9583 5.66667 12.9583H3.16667C2.55888 12.9583 1.97598 12.7169 1.54621 12.2871C1.11644 11.8573 0.875 11.2745 0.875 10.6667V8.16667C0.874894 7.66259 1.04099 7.17254 1.34757 6.77241C1.65414 6.37228 2.08409 6.08439 2.57083 5.95333C2.88917 3.03333 5.72833 0.875 9 0.875C12.2717 0.875 15.1108 3.03333 15.4292 5.95333C15.9158 6.08452 16.3457 6.37244 16.6523 6.77254C16.9588 7.17265 17.125 7.66263 17.125 8.16667V10.6667C17.125 11.1722 16.9579 11.6636 16.6497 12.0644C16.3415 12.4651 15.9095 12.7528 15.4208 12.8825C15.2882 13.828 14.8184 14.6937 14.0979 15.3202C13.3774 15.9467 12.4548 16.2917 11.5 16.2917H10.5458C10.4008 16.6502 10.1356 16.9472 9.79559 17.1316C9.45562 17.3161 9.06209 17.3765 8.68243 17.3026C8.30277 17.2288 7.96063 17.0251 7.71464 16.7267C7.46865 16.4282 7.33413 16.0534 7.33413 15.6667C7.33413 15.2799 7.46865 14.9051 7.71464 14.6067C7.96063 14.3082 8.30277 14.1046 8.68243 14.0307C9.06209 13.9568 9.45562 14.0173 9.79559 14.2017C10.1356 14.3862 10.4008 14.6831 10.5458 15.0417H11.5C12.1097 15.0417 12.7015 14.836 13.1799 14.4579C13.6582 14.0799 13.995 13.5515 14.1358 12.9583H12.3333C12.1676 12.9583 12.0086 12.8925 11.8914 12.7753C11.7742 12.6581 11.7083 12.4991 11.7083 12.3333V6.5C11.7083 6.33424 11.7742 6.17527 11.8914 6.05806C12.0086 5.94085 12.1676 5.875 12.3333 5.875H14.1542C13.7967 3.81667 11.7008 2.125 9 2.125ZM3.16667 7.125C2.59167 7.125 2.125 7.59167 2.125 8.16667V10.6667C2.125 11.2417 2.59167 11.7083 3.16667 11.7083H5.04167V7.125H3.16667ZM15.875 8.16667C15.875 7.59167 15.4083 7.125 14.8333 7.125H12.9583V11.7083H14.8333C15.4083 11.7083 15.875 11.2417 15.875 10.6667V8.16667Z"
        fill={fill}
      />
    </svg>
  );
};

export const LogoutIcons = ({ fill = "#89A594" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        id="vuesax_outline_logout"
        data-name="vuesax/outline/logout"
        transform="translate(-748 -444)"
      >
        <g id="logout">
          <path
            id="Vector"
            d="M7.092,20.54h-.13c-4.44,0-6.58-1.75-6.95-5.67a.751.751,0,0,1,.68-.82.765.765,0,0,1,.82.68c.29,3.14,1.77,4.31,5.46,4.31H7.1c4.07,0,5.51-1.44,5.51-5.51V7.01c0-4.07-1.44-5.51-5.51-5.51h-.13c-3.71,0-5.19,1.19-5.46,4.39A.758.758,0,0,1,0,5.76C.342,1.78,2.492,0,6.962,0h.13C12,0,14.1,2.1,14.1,7.01v6.52C14.1,18.44,12,20.54,7.092,20.54Z"
            transform="translate(756.148 445.73)"
            fill={fill}
          ></path>
          <path
            id="Vector-2"
            data-name="Vector"
            d="M12.13,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0H12.13a.755.755,0,0,1,.75.75A.755.755,0,0,1,12.13,1.5Z"
            transform="translate(750.87 455.25)"
            fill={fill}
          ></path>
          <path
            id="Vector-3"
            data-name="Vector"
            d="M4.1,8.2a.742.742,0,0,1-.53-.22L.218,4.628a.754.754,0,0,1,0-1.06L3.568.218a.75.75,0,0,1,1.06,1.06L1.807,4.1l2.82,2.82a.754.754,0,0,1,0,1.06A.725.725,0,0,1,4.1,8.2Z"
            transform="translate(749.753 451.902)"
            fill={fill}
          ></path>
          <path
            id="Vector-4"
            data-name="Vector"
            d="M0,0H24V24H0Z"
            transform="translate(748 444)"
            fill="none"
            opacity="0"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const LessThanIcons = ({ stroke = "#107038" }) => {
  return (
    <svg
      width="7"
      height="15"
      viewBox="0 0 7 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 14L1 7.5L6 1"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GreaterThanIcons = ({ stroke = "#107038" }) => {
  return (
    <svg
      width="7"
      height="15"
      viewBox="0 0 7 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 0.999999L6 7.5L1 14"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoToolsIcons = () => {
  return (
    <svg
      width="150"
      height="120"
      viewBox="0 0 150 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.2 39C126.52 39 128.4 40.8804 128.4 43.2C128.4 45.5196 126.52 47.4 124.2 47.4H100.2C102.52 47.4 104.4 49.2804 104.4 51.6C104.4 53.9196 102.52 55.8 100.2 55.8H113.4C115.72 55.8 117.6 57.6804 117.6 60C117.6 62.3196 115.72 64.2 113.4 64.2H107.296C104.371 64.2 102 66.0804 102 68.4C102 69.9464 103.2 71.3464 105.6 72.6C107.92 72.6 109.8 74.4804 109.8 76.8C109.8 79.1196 107.92 81 105.6 81H55.7999C53.4804 81 51.5999 79.1196 51.5999 76.8C51.5999 74.4804 53.4804 72.6 55.7999 72.6H32.4C30.0804 72.6 28.2 70.7196 28.2 68.4C28.2 66.0804 30.0804 64.2 32.4 64.2H56.4C58.7195 64.2 60.5999 62.3196 60.5999 60C60.5999 57.6804 58.7195 55.8 56.4 55.8H41.4C39.0804 55.8 37.2 53.9196 37.2 51.6C37.2 49.2804 39.0804 47.4 41.4 47.4H65.3999C63.0804 47.4 61.1999 45.5196 61.1999 43.2C61.1999 40.8804 63.0804 39 65.3999 39H124.2ZM124.2 55.8C126.52 55.8 128.4 57.6804 128.4 60C128.4 62.3196 126.52 64.2 124.2 64.2C121.88 64.2 120 62.3196 120 60C120 57.6804 121.88 55.8 124.2 55.8Z"
        fill="#E2EDE7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.2031 38.4003L97.7842 79.1059L98.2856 83.1897C98.4472 84.5053 97.5116 85.7028 96.196 85.8643L61.0599 90.1785C59.7443 90.34 58.5468 89.4045 58.3853 88.0889L52.9758 44.0324C52.8951 43.3746 53.3628 42.7758 54.0206 42.6951C54.0248 42.6946 54.029 42.6941 54.0331 42.6936L56.9481 42.3666M59.3053 42.1021L62.0575 41.7934L59.3053 42.1021Z"
        fill="white"
      />
      <path
        d="M93.4415 38.2305C93.3477 37.5466 92.7173 37.0681 92.0333 37.1619C91.3493 37.2557 90.8709 37.8862 90.9647 38.5701L93.4415 38.2305ZM97.7842 79.1059L99.0249 78.9536C99.0242 78.9478 99.0234 78.942 99.0226 78.9361L97.7842 79.1059ZM98.2856 83.1897L99.5263 83.0374L98.2856 83.1897ZM96.196 85.8643L96.3484 87.105L96.196 85.8643ZM61.0599 90.1785L61.2122 91.4192L61.0599 90.1785ZM58.3853 88.0889L59.626 87.9365L58.3853 88.0889ZM54.0331 42.6936L54.1725 43.9358L54.0331 42.6936ZM57.0875 43.6088C57.7735 43.5319 58.2673 42.9133 58.1903 42.2273C58.1134 41.5412 57.4948 41.0474 56.8088 41.1244L57.0875 43.6088ZM59.166 40.8599C58.4799 40.9369 57.9861 41.5554 58.0631 42.2414C58.1401 42.9275 58.7586 43.4213 59.4446 43.3443L59.166 40.8599ZM62.1969 43.0356C62.8829 42.9586 63.3767 42.3401 63.2997 41.654C63.2228 40.968 62.6042 40.4742 61.9182 40.5512L62.1969 43.0356ZM90.9647 38.5701L96.5458 79.2757L99.0226 78.9361L93.4415 38.2305L90.9647 38.5701ZM96.5435 79.2583L97.045 83.3421L99.5263 83.0374L99.0249 78.9536L96.5435 79.2583ZM97.045 83.3421C97.1224 83.9725 96.6741 84.5462 96.0437 84.6236L96.3484 87.105C98.3492 86.8593 99.772 85.0382 99.5263 83.0374L97.045 83.3421ZM96.0437 84.6236L60.9076 88.9378L61.2122 91.4192L96.3484 87.105L96.0437 84.6236ZM60.9076 88.9378C60.2772 89.0152 59.7034 88.5669 59.626 87.9365L57.1446 88.2412C57.3903 90.242 59.2114 91.6649 61.2122 91.4192L60.9076 88.9378ZM59.626 87.9365L54.2165 43.88L51.7352 44.1847L57.1446 88.2412L59.626 87.9365ZM54.2165 43.88C54.2199 43.9074 54.2004 43.9324 54.173 43.9357L53.8683 41.4544C52.5253 41.6193 51.5702 42.8417 51.7352 44.1847L54.2165 43.88ZM54.173 43.9357L54.1725 43.9358L53.8938 41.4514C53.8853 41.4523 53.8768 41.4533 53.8683 41.4544L54.173 43.9357ZM54.1725 43.9358L57.0875 43.6088L56.8088 41.1244L53.8938 41.4514L54.1725 43.9358ZM59.4446 43.3443L62.1969 43.0356L61.9182 40.5512L59.166 40.8599L59.4446 43.3443Z"
        fill="#107038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.6841 40.9614L95.7359 77.8516L96.1903 81.5525C96.3367 82.7448 95.5003 83.8286 94.3221 83.9732L62.8569 87.8367C61.6788 87.9813 60.605 87.1321 60.4586 85.9398L55.6661 46.9079C55.5315 45.8116 56.3111 44.8137 57.4075 44.6791L60.506 44.2987"
        fill="#F6F7F8"
      />
      <path
        d="M65.2532 34C65.2532 32.4812 66.4844 31.25 68.0032 31.25H93.0748C93.8038 31.25 94.503 31.5395 95.0187 32.0549L102.147 39.1788C102.663 39.6946 102.953 40.3943 102.953 41.124V76.4C102.953 77.9188 101.722 79.15 100.203 79.15H68.0032C66.4844 79.15 65.2532 77.9188 65.2532 76.4V34Z"
        fill="white"
        stroke="#107038"
        strokeWidth="2.5"
      />
      <path
        d="M94.0032 31.4419V38.4002C94.0032 39.3943 94.8091 40.2002 95.8032 40.2002H100.563"
        stroke="#107038"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.8 70.8002H86.4M70.8 40.2002H86.4H70.8ZM70.8 47.4002H96.6H70.8ZM70.8 55.2002H96.6H70.8ZM70.8 63.0002H96.6H70.8Z"
        stroke="#737373"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftArrowTCIcons = ({
  stroke = "#7B7F82",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g
        id="vuesax_linear_arrow-left"
        data-name="vuesax/linear/arrow-left"
        transform="translate(-684 -188)"
      >
        <g id="arrow-left">
          <path
            id="Vector"
            d="M6.07,0,0,6.07l6.07,6.07"
            transform="translate(687.5 193.93)"
            fill="none"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M16.83,0H0"
            transform="translate(687.67 200)"
            fill="none"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M0,0H24V24H0Z"
            transform="translate(708 212) rotate(180)"
            fill="none"
            opacity="0"
          />
        </g>
      </g>
    </svg>
  );
};

export const SearchIcons = ({ size = "24", stroke = "#283745" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17C10.9193 17 11.8295 16.8189 12.6788 16.4672C13.5281 16.1154 14.2997 15.5998 14.9497 14.9497C15.5998 14.2997 16.1154 13.5281 16.4672 12.6788C16.8189 11.8295 17 10.9193 17 10C17 9.08075 16.8189 8.17049 16.4672 7.32122C16.1154 6.47194 15.5998 5.70026 14.9497 5.05025C14.2997 4.40024 13.5281 3.88463 12.6788 3.53284C11.8295 3.18106 10.9193 3 10 3C8.14348 3 6.36301 3.7375 5.05025 5.05025C3.7375 6.36301 3 8.14348 3 10C3 11.8565 3.7375 13.637 5.05025 14.9497C6.36301 16.2625 8.14348 17 10 17Z"
        stroke={stroke}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 21L15 15"
        stroke={stroke}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Attract = ({ fill = "none", stroke = "none", width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9584 7.6L12.4168 6.05833C11.8334 5.475 11.0334 5.50833 10.6418 6.125L9.78345 7.48333L12.5251 10.225L13.8834 9.36666C14.4751 9 14.5084 8.14167 13.9584 7.6Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.78338 7.48333L7.79172 7.36667C6.67505 7.3 6.29172 7.64167 6.16672 8.7L5.66672 12.925C5.55838 13.8167 6.20005 14.45 7.09172 14.35L11.3167 13.85C12.375 13.725 12.7584 13.3417 12.65 12.225L12.5334 10.2333"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.2417 13.7667L7.78337 12.225"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50008 18.3333H12.5001C16.6667 18.3333 18.3334 16.6667 18.3334 12.5V7.5C18.3334 3.33333 16.6667 1.66666 12.5001 1.66666H7.50008C3.33341 1.66666 1.66675 3.33333 1.66675 7.5V12.5C1.66675 16.6667 3.33341 18.3333 7.50008 18.3333Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AttractActive = ({
  fill = "none",
  stroke = "none",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4917 0.666748H5.50841C2.47508 0.666748 0.666748 2.47508 0.666748 5.50841V12.4834C0.666748 15.5251 2.47508 17.3334 5.50841 17.3334H12.4834C15.5167 17.3334 17.3251 15.5251 17.3251 12.4917V5.50841C17.3334 2.47508 15.5251 0.666748 12.4917 0.666748ZM12.8834 8.37508L11.5334 9.22508L11.6501 11.2251C11.7584 12.3417 11.3751 12.7251 10.3167 12.8501L6.09175 13.3501V13.3501C5.85988 13.3817 5.78118 13.119 5.94665 12.9535L7.23341 11.6667C7.47508 11.4251 7.47508 11.0251 7.23341 10.7834C6.98341 10.5417 6.59175 10.5417 6.34175 10.7834L5.0624 12.0693C4.89758 12.2349 4.63517 12.1566 4.66675 11.9251V11.9251L5.15841 7.70008C5.29175 6.64175 5.67508 6.30008 6.79175 6.36675L8.78341 6.48341L9.64175 5.12508C10.0334 4.50841 10.8334 4.47508 11.4167 5.05841L12.9584 6.60008C13.5084 7.14175 13.4751 8.00008 12.8834 8.37508Z"
        fill={fill}
      />
    </svg>
  );
};

export const Report = ({ stroke = "#8EAF9E", height }) => {
  return (
    <svg
      width="24"
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 5.83341V14.1667C17.5 16.6667 16.25 18.3334 13.3333 18.3334H6.66667C3.75 18.3334 2.5 16.6667 2.5 14.1667V5.83341C2.5 3.33341 3.75 1.66675 6.66667 1.66675H13.3333C16.25 1.66675 17.5 3.33341 17.5 5.83341Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0833 3.75V5.41667C12.0833 6.33333 12.8333 7.08333 13.7499 7.08333H15.4166"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 10.8333H10.0001"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 14.1667H13.3334"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddBox1 = ({ fill = "none", stroke = "none", width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12H16"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16V8"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Upload1 = ({ fill = "none", stroke = "none", width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.325 19.5004C4.99167 19.5004 3.85417 19.0296 2.9125 18.0879C1.97083 17.1462 1.5 16.0087 1.5 14.6754C1.5 13.4421 1.9125 12.3587 2.7375 11.4254C3.5625 10.4921 4.58333 9.96706 5.8 9.85039C6.05 8.30039 6.7625 7.02539 7.9375 6.02539C9.1125 5.02539 10.4833 4.52539 12.05 4.52539C13.8 4.52539 15.275 5.15456 16.475 6.41289C17.675 7.67122 18.275 9.18372 18.275 10.9504V11.9004H18.575C19.675 11.8671 20.6042 12.2129 21.3625 12.9379C22.1208 13.6629 22.5 14.5837 22.5 15.7004C22.5 16.7337 22.1292 17.6254 21.3875 18.3754C20.6458 19.1254 19.7583 19.5004 18.725 19.5004H12.875C12.475 19.5004 12.1333 19.3587 11.85 19.0754C11.5667 18.7921 11.425 18.4504 11.425 18.0504V11.6254L9.625 13.4504C9.50833 13.5671 9.375 13.6212 9.225 13.6129C9.075 13.6046 8.94167 13.5421 8.825 13.4254C8.725 13.3087 8.675 13.1712 8.675 13.0129C8.675 12.8546 8.725 12.7171 8.825 12.6004L11.5 9.95039C11.5667 9.88372 11.6417 9.82956 11.725 9.78789C11.8083 9.74622 11.9 9.72539 12 9.72539C12.1 9.72539 12.1917 9.74622 12.275 9.78789C12.3583 9.82956 12.4333 9.88372 12.5 9.95039L15.175 12.6254C15.2917 12.7421 15.35 12.8754 15.35 13.0254C15.35 13.1754 15.2917 13.3087 15.175 13.4254C15.075 13.5421 14.9417 13.6004 14.775 13.6004C14.6083 13.6004 14.475 13.5337 14.375 13.4004L12.575 11.6254V18.0504C12.575 18.1337 12.6042 18.2087 12.6625 18.2754C12.7208 18.3421 12.7917 18.3754 12.875 18.3754H18.7C19.4333 18.3754 20.0625 18.1129 20.5875 17.5879C21.1125 17.0629 21.375 16.4337 21.375 15.7004C21.375 14.9671 21.1125 14.3421 20.5875 13.8254C20.0625 13.3087 19.4333 13.0504 18.7 13.0504H17.15V10.9504C17.15 9.50039 16.65 8.25456 15.65 7.21289C14.65 6.17122 13.425 5.65039 11.975 5.65039C10.5083 5.65039 9.27083 6.17122 8.2625 7.21289C7.25417 8.25456 6.75 9.50039 6.75 10.9504H6.25C5.26667 10.9504 4.41667 11.3087 3.7 12.0254C2.98333 12.7421 2.625 13.6254 2.625 14.6754C2.625 15.6921 2.9875 16.5629 3.7125 17.2879C4.4375 18.0129 5.30833 18.3754 6.325 18.3754H8.975C9.14167 18.3754 9.27917 18.4296 9.3875 18.5379C9.49583 18.6462 9.55 18.7837 9.55 18.9504C9.55 19.1004 9.49583 19.2296 9.3875 19.3379C9.27917 19.4462 9.14167 19.5004 8.975 19.5004H6.325Z"
        fill={fill}
      />
    </svg>
  );
};
export const Search = () => {
  return (
    <svg
      id="vuesax_linear_search-normal"
      data-name="vuesax/linear/search-normal"
      xmlns="http://www.w3.org/2000/svg"
      width="16.5"
      height="16.5"
      viewBox="0 0 16.5 16.5"
    >
      <g id="search-normal">
        <path
          id="Vector"
          d="M13.021,6.51A6.51,6.51,0,1,1,6.51,0,6.51,6.51,0,0,1,13.021,6.51Z"
          transform="translate(1.392 1.392)"
          fill="none"
          stroke="#7b7f82"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M1.392,1.392,0,0"
          transform="translate(13.716 13.716)"
          fill="none"
          stroke="#7b7f82"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H16.5V16.5H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
};
export const List2 = ({ fill = "none", stroke = "none", width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.90299 10.855L5.90299 10.855C5.58935 10.537 5.20209 10.375 4.75552 10.375C4.31015 10.375 3.92208 10.5342 3.60496 10.847C3.287 11.1606 3.125 11.5479 3.125 11.9945C3.125 12.4399 3.28422 12.8279 3.59702 13.145C3.91065 13.463 4.29791 13.625 4.74448 13.625C5.18985 13.625 5.57792 13.4658 5.89504 13.153C6.213 12.8394 6.375 12.4521 6.375 12.0055C6.375 11.5602 6.21578 11.1721 5.90299 10.855ZM13.153 10.855L13.153 10.855C12.8394 10.537 12.4521 10.375 12.0055 10.375C11.5601 10.375 11.1721 10.5342 10.855 10.847C10.537 11.1606 10.375 11.5479 10.375 11.9945C10.375 12.4399 10.5342 12.8279 10.847 13.145C11.1606 13.463 11.5479 13.625 11.9945 13.625C12.4399 13.625 12.8279 13.4658 13.145 13.153C13.463 12.8394 13.625 12.4521 13.625 12.0055C13.625 11.5602 13.4658 11.1721 13.153 10.855ZM18.105 10.847L18.105 10.847C17.787 11.1606 17.625 11.5479 17.625 11.9945C17.625 12.4399 17.7842 12.8279 18.097 13.145C18.4106 13.463 18.7979 13.625 19.2445 13.625C19.6898 13.625 20.0779 13.4658 20.395 13.153L20.2195 12.975L20.395 13.153C20.713 12.8394 20.875 12.4521 20.875 12.0055C20.875 11.5602 20.7158 11.1721 20.403 10.855L20.403 10.855C20.0894 10.537 19.7021 10.375 19.2555 10.375C18.8102 10.375 18.4221 10.5342 18.105 10.847Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.5"
      />
    </svg>
  );
};
export const List1 = ({ fill = "none", stroke = "none", width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3701 8.87988H17.6201"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.37988 8.87988L7.12988 9.62988L9.37988 7.37988"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3701 15.8799H17.6201"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.37988 15.8799L7.12988 16.6299L9.37988 14.3799"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Wand1 = ({ fill = "none", stroke = "none", width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99998 21.8729C4.4326 21.8722 3.87814 21.7034 3.40657 21.3879C2.93499 21.0724 2.56744 20.6243 2.35028 20.1001C2.13312 19.576 2.07609 18.9992 2.18637 18.4426C2.29666 17.8861 2.56933 17.3747 2.96998 16.9729L15.97 3.9729C16.5085 3.43437 17.2389 3.13184 18.0005 3.13184C18.7621 3.13184 19.4925 3.43437 20.031 3.9729C20.5695 4.51142 20.872 5.24181 20.872 6.0034C20.872 6.76498 20.5695 7.49537 20.031 8.0339L7.03098 21.0339C6.76471 21.3011 6.44811 21.5128 6.0995 21.6568C5.75088 21.8008 5.37717 21.8743 4.99998 21.8729ZM18 4.6279C17.8199 4.62718 17.6414 4.66216 17.4749 4.73082C17.3085 4.79948 17.1572 4.90045 17.03 5.0279L4.02998 18.0279C3.77285 18.285 3.6284 18.6338 3.6284 18.9974C3.6284 19.361 3.77285 19.7098 4.02998 19.9669C4.28711 20.224 4.63584 20.3685 4.99948 20.3685C5.36311 20.3685 5.71185 20.224 5.96898 19.9669L18.969 6.9669C19.1592 6.77474 19.2885 6.53069 19.3406 6.26535C19.3927 6.00001 19.3653 5.7252 19.2618 5.47538C19.1583 5.22557 18.9833 5.01188 18.7588 4.86111C18.5344 4.71034 18.2704 4.62921 18 4.6279Z"
        fill={fill}
      />
      <path
        d="M18.0101 9.74006C17.9116 9.74009 17.8141 9.72066 17.7231 9.68291C17.6322 9.64516 17.5496 9.58982 17.4801 9.52006L14.4801 6.52006C14.3396 6.37944 14.2607 6.18881 14.2607 5.99006C14.2607 5.79131 14.3396 5.60069 14.4801 5.46006C14.6207 5.31961 14.8113 5.24072 15.0101 5.24072C15.2088 5.24072 15.3995 5.31961 15.5401 5.46006L18.5401 8.46006C18.6448 8.56495 18.7162 8.69853 18.745 8.84393C18.7739 8.98933 18.7591 9.14002 18.7024 9.27699C18.6457 9.41395 18.5496 9.53103 18.4264 9.61345C18.3032 9.69587 18.1583 9.73993 18.0101 9.74006Z"
        fill={fill}
      />
      <path
        d="M6.99994 1.5002C7.04766 1.50011 7.09514 1.50684 7.14094 1.5202L8.49994 1.9202L9.85894 1.5202C9.94501 1.49496 10.0363 1.49334 10.1232 1.51551C10.2101 1.53768 10.2895 1.58282 10.3529 1.6462C10.4167 1.70966 10.4621 1.78914 10.4845 1.87625C10.5068 1.96337 10.5052 2.0549 10.4799 2.1412L10.0809 3.5002L10.4809 4.8592C10.5064 4.94542 10.5081 5.03689 10.4859 5.12399C10.4637 5.2111 10.4185 5.29061 10.3549 5.35417C10.2914 5.41773 10.2118 5.46298 10.1247 5.48516C10.0376 5.50734 9.94616 5.50562 9.85994 5.4802L8.49994 5.0812L7.14094 5.4812C7.05487 5.50644 6.96359 5.50806 6.87668 5.48589C6.78976 5.46372 6.71041 5.41858 6.64694 5.3552C6.58303 5.29165 6.53749 5.212 6.51514 5.12469C6.49278 5.03738 6.49444 4.94565 6.51994 4.8592L6.91994 3.5002L6.51994 2.1412C6.49451 2.05499 6.49279 1.96351 6.51496 1.8764C6.53714 1.78929 6.58238 1.70977 6.64594 1.6462C6.69246 1.5998 6.74767 1.56302 6.80841 1.53797C6.86915 1.51292 6.93424 1.50008 6.99994 1.5002ZM8.49994 2.9402C8.45223 2.9403 8.40475 2.93356 8.35894 2.9202L7.73694 2.7372L7.91894 3.3592C7.9458 3.45094 7.9458 3.54846 7.91894 3.6402L7.73694 4.2622L8.35894 4.0802C8.45068 4.05334 8.5482 4.05334 8.63994 4.0802L9.26194 4.2622L9.07994 3.6412C9.05308 3.54946 9.05308 3.45194 9.07994 3.3602L9.26294 2.7372L8.64094 2.9202C8.59514 2.93356 8.54766 2.9403 8.49994 2.9402Z"
        fill={fill}
      />
      <path
        d="M2.99994 7.5002C3.04766 7.50011 3.09514 7.50684 3.14094 7.5202L4.49994 7.9202L5.85894 7.5202C5.94501 7.49496 6.03629 7.49334 6.12321 7.51551C6.21012 7.53768 6.28947 7.58282 6.35294 7.6462C6.41667 7.70966 6.46211 7.78914 6.48446 7.87625C6.50681 7.96337 6.50525 8.0549 6.47994 8.1412L6.08094 9.5002L6.48094 10.8592C6.50636 10.9454 6.50808 11.0369 6.4859 11.124C6.46372 11.2111 6.41847 11.2906 6.35491 11.3542C6.29135 11.4177 6.21184 11.463 6.12473 11.4852C6.03763 11.5073 5.94616 11.5056 5.85994 11.4802L4.49994 11.0812L3.14094 11.4812C3.05487 11.5064 2.96359 11.5081 2.87668 11.4859C2.78976 11.4637 2.71041 11.4186 2.64694 11.3552C2.58303 11.2916 2.53749 11.212 2.51514 11.1247C2.49278 11.0374 2.49444 10.9456 2.51994 10.8592L2.91994 9.5002L2.51994 8.1412C2.49451 8.05499 2.49279 7.96351 2.51496 7.8764C2.53714 7.78929 2.58238 7.70977 2.64594 7.6462C2.69246 7.5998 2.74767 7.56302 2.80841 7.53797C2.86915 7.51292 2.93424 7.50008 2.99994 7.5002ZM4.49994 8.9402C4.45223 8.9403 4.40475 8.93356 4.35894 8.9202L3.73694 8.7372L3.91894 9.3592C3.9458 9.45094 3.9458 9.54846 3.91894 9.6402L3.73694 10.2622L4.35894 10.0802C4.45068 10.0533 4.5482 10.0533 4.63994 10.0802L5.26194 10.2622L5.07994 9.6412C5.05308 9.54946 5.05308 9.45194 5.07994 9.3602L5.26294 8.7372L4.64094 8.9202C4.59514 8.93356 4.54766 8.9403 4.49994 8.9402Z"
        fill={fill}
      />
      <path
        d="M17.9999 12.5002C18.0477 12.5001 18.0951 12.5068 18.1409 12.5202L19.4999 12.9202L20.8589 12.5202C20.945 12.495 21.0363 12.4933 21.1232 12.5155C21.2101 12.5377 21.2895 12.5828 21.3529 12.6462C21.4167 12.7097 21.4621 12.7891 21.4845 12.8763C21.5068 12.9634 21.5052 13.0549 21.4799 13.1412L21.0809 14.5002L21.4809 15.8592C21.5064 15.9454 21.5081 16.0369 21.4859 16.124C21.4637 16.2111 21.4185 16.2906 21.3549 16.3542C21.2914 16.4177 21.2118 16.463 21.1247 16.4852C21.0376 16.5073 20.9462 16.5056 20.8599 16.4802L19.4999 16.0812L18.1409 16.4812C18.0549 16.5064 17.9636 16.5081 17.8767 16.4859C17.7898 16.4637 17.7104 16.4186 17.6469 16.3552C17.583 16.2916 17.5375 16.212 17.5151 16.1247C17.4928 16.0374 17.4944 15.9456 17.5199 15.8592L17.9199 14.5002L17.5199 13.1412C17.4945 13.055 17.4928 12.9635 17.515 12.8764C17.5371 12.7893 17.5824 12.7098 17.6459 12.6462C17.6925 12.5998 17.7477 12.563 17.8084 12.538C17.8692 12.5129 17.9342 12.5001 17.9999 12.5002ZM19.4999 13.9402C19.4522 13.9403 19.4047 13.9336 19.3589 13.9202L18.7369 13.7372L18.9189 14.3592C18.9458 14.4509 18.9458 14.5485 18.9189 14.6402L18.7369 15.2622L19.3589 15.0802C19.4507 15.0533 19.5482 15.0533 19.6399 15.0802L20.2619 15.2622L20.0799 14.6412C20.0531 14.5495 20.0531 14.4519 20.0799 14.3602L20.2629 13.7372L19.6409 13.9202C19.5951 13.9336 19.5477 13.9403 19.4999 13.9402Z"
        fill={fill}
      />
    </svg>
  );
};
export const StickyNote1 = ({
  fill = "none",
  stroke = "none",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2V5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2V5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11H15"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 15H12"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 22H9C4 22 3 19.94 3 15.82V9.65C3 4.95 4.67 3.69 8 3.5H16C19.33 3.68 21 4.95 21 9.65V16"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 16L15 22V19C15 17 16 16 18 16H21Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const StickyNoteFill1 = ({
  fill = "none",
  stroke = "none",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.29004 6.29C7.87004 6.29 7.54004 5.95 7.54004 5.54V2.75C7.54004 2.34 7.87004 2 8.29004 2C8.71004 2 9.04004 2.34 9.04004 2.75V5.53C9.04004 5.95 8.71004 6.29 8.29004 6.29Z"
        fill={fill}
      />
      <path
        d="M15.71 6.29C15.29 6.29 14.96 5.95 14.96 5.54V2.75C14.96 2.33 15.3 2 15.71 2C16.13 2 16.46 2.34 16.46 2.75V5.53C16.46 5.95 16.13 6.29 15.71 6.29Z"
        fill={fill}
      />
      <path
        d="M21.4999 15.8197C21.4999 15.9697 21.4499 16.1197 21.3199 16.2497C19.8699 17.7097 17.2899 20.3097 15.8099 21.7997C15.6799 21.9397 15.5099 21.9997 15.3399 21.9997C15.0099 21.9997 14.6899 21.7397 14.6899 21.3597V17.8597C14.6899 16.3997 15.9299 15.1897 17.4499 15.1897C18.3999 15.1797 19.7199 15.1797 20.8499 15.1797C21.2399 15.1797 21.4999 15.4897 21.4999 15.8197Z"
        fill={fill}
      />
      <path
        d="M21.4999 15.8197C21.4999 15.9697 21.4499 16.1197 21.3199 16.2497C19.8699 17.7097 17.2899 20.3097 15.8099 21.7997C15.6799 21.9397 15.5099 21.9997 15.3399 21.9997C15.0099 21.9997 14.6899 21.7397 14.6899 21.3597V17.8597C14.6899 16.3997 15.9299 15.1897 17.4499 15.1897C18.3999 15.1797 19.7199 15.1797 20.8499 15.1797C21.2399 15.1797 21.4999 15.4897 21.4999 15.8197Z"
        fill={fill}
      />
      <path
        d="M19.57 4.5C18.91 4.01 17.96 4.48 17.96 5.31V5.41C17.96 6.58 17.12 7.66 15.95 7.78C14.6 7.92 13.46 6.86 13.46 5.54V4.5C13.46 3.95 13.01 3.5 12.46 3.5H11.54C10.99 3.5 10.54 3.95 10.54 4.5V5.41C10.54 6.29 10.07 7.11 9.34 7.51C9.3 7.54 9.26 7.56 9.22 7.58C9.21 7.58 9.21 7.59 9.2 7.59C9.13 7.62 9.06 7.65 8.98 7.68C8.96 7.69 8.94 7.69 8.92 7.7C8.8 7.74 8.67 7.77 8.53 7.78H8.52C8.37 7.8 8.21 7.8 8.06 7.78H8.05C7.91 7.77 7.78 7.74 7.66 7.7C7.56 7.67 7.46 7.63 7.36 7.58C6.58 7.23 6.04 6.45 6.04 5.54V5.31C6.04 4.54 5.22 4.08 4.57 4.41C4.56 4.42 4.55 4.42 4.54 4.43H4.53C4.46 4.48 4.4 4.53 4.33 4.58C4.22 4.67 4.11 4.76 4.01 4.86C3.94 4.93 3.87 5 3.81 5.07C3.73 5.15 3.66 5.23 3.59 5.32C3.54 5.38 3.48 5.44 3.44 5.51C3.39 5.57 3.35 5.64 3.31 5.7C3.3 5.71 3.29 5.72 3.28 5.74C3.19 5.87 3.11 6.02 3.04 6.16C3.02 6.18 3.01 6.19 3.01 6.21C2.95 6.33 2.89 6.45 2.85 6.58C2.82 6.63 2.81 6.67 2.79 6.72C2.77 6.76 2.76 6.81 2.74 6.85C2.71 6.95 2.68 7.06 2.65 7.17C2.61 7.31 2.58 7.46 2.56 7.61C2.54 7.72 2.53 7.83 2.52 7.95C2.51 8.09 2.5 8.23 2.5 8.37V17.13C2.5 19.82 4.68 22 7.37 22H12.19C12.74 22 13.19 21.55 13.19 21V17.86C13.19 15.56 15.1 13.69 17.45 13.69C17.98 13.68 19.27 13.68 20.5 13.68C21.05 13.68 21.5 13.23 21.5 12.68V8.37C21.5 6.78 20.74 5.39 19.57 4.5ZM11.13 15.91C11.04 16.21 10.76 16.42 10.43 16.42H6.79C6.74 16.42 6.7 16.42 6.66 16.4C6.3 16.35 6.04 16.04 6.04 15.67C6.04 15.25 6.37 14.91 6.79 14.91H10.43C10.84 14.91 11.18 15.25 11.18 15.67C11.18 15.75 11.17 15.84 11.13 15.91ZM13.91 12.2C13.82 12.5 13.54 12.71 13.21 12.71H6.79C6.74 12.71 6.7 12.71 6.66 12.69C6.3 12.64 6.04 12.33 6.04 11.96C6.04 11.54 6.37 11.2 6.79 11.2H13.21C13.63 11.2 13.96 11.54 13.96 11.96C13.96 12.04 13.95 12.13 13.91 12.2Z"
        fill={fill}
      />
    </svg>
  );
};
export const WandFill1 = ({
  fill = "none",
  stroke = "none",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 7.50023L18.01 8.99023L15.01 5.99023L16.5 4.50023C16.8978 4.1024 17.4374 3.87891 18 3.87891C18.5626 3.87891 19.1022 4.1024 19.5 4.50023C19.8978 4.89805 20.1213 5.43762 20.1213 6.00023C20.1213 6.56284 19.8978 7.1024 19.5 7.50023Z"
        fill={fill}
      />
      <path
        d="M17.31 9.7002L6.49998 20.5002C6.10216 20.898 5.56259 21.1215 4.99998 21.1215C4.43737 21.1215 3.89781 20.898 3.49998 20.5002C3.10216 20.1024 2.87866 19.5628 2.87866 19.0002C2.87866 18.4376 3.10216 17.898 3.49998 17.5002L14.311 6.7002L17.31 9.7002Z"
        fill={fill}
      />
      <path
        d="M9.95011 3.50031L10.3601 2.11031C10.3783 2.04611 10.3795 1.97831 10.3638 1.91348C10.348 1.84865 10.3157 1.78899 10.2701 1.74031C10.2218 1.69069 10.1609 1.65516 10.094 1.63754C10.027 1.61993 9.95656 1.62088 9.89011 1.64031L8.50011 2.05031L7.11011 1.64031C7.04591 1.62215 6.9781 1.62089 6.91327 1.63666C6.84844 1.65243 6.78879 1.68469 6.74011 1.73031C6.69251 1.77773 6.65891 1.83736 6.64303 1.90264C6.62715 1.96793 6.6296 2.03633 6.65011 2.10031L7.05011 3.50031L6.64011 4.89031C6.62194 4.95451 6.62068 5.02232 6.63645 5.08715C6.65222 5.15198 6.68448 5.21163 6.73011 5.26031C6.77752 5.30791 6.83716 5.3415 6.90244 5.35738C6.96773 5.37326 7.03613 5.37082 7.10011 5.35031L8.50011 4.95031L9.89011 5.36031C9.92573 5.37179 9.96272 5.37852 10.0001 5.38031C10.1007 5.37892 10.1972 5.33964 10.2701 5.27031C10.3177 5.2229 10.3513 5.16326 10.3672 5.09798C10.3831 5.03269 10.3806 4.96429 10.3601 4.90031L9.95011 3.50031Z"
        fill={fill}
      />
      <path
        d="M5.95011 9.49962L6.36011 8.10962C6.37827 8.04542 6.37953 7.97761 6.36376 7.91278C6.34799 7.84796 6.31573 7.7883 6.27011 7.73962C6.22269 7.69202 6.16306 7.65843 6.09777 7.64255C6.03249 7.62667 5.96409 7.62911 5.90011 7.64962L4.50011 8.04962L3.11011 7.63962C3.04591 7.62145 2.9781 7.6202 2.91327 7.63596C2.84844 7.65173 2.78879 7.684 2.74011 7.72962C2.69251 7.77704 2.65891 7.83667 2.64303 7.90195C2.62715 7.96724 2.6296 8.03564 2.65011 8.09962L3.05011 9.49962L2.64011 10.8896C2.62194 10.9538 2.62068 11.0216 2.63645 11.0865C2.65222 11.1513 2.68448 11.2109 2.73011 11.2596C2.77752 11.3072 2.83716 11.3408 2.90244 11.3567C2.96773 11.3726 3.03613 11.3701 3.10011 11.3496L4.49011 10.9396L5.88011 11.3496C5.91608 11.3584 5.95315 11.3617 5.99011 11.3596C6.09074 11.3582 6.18715 11.3189 6.26011 11.2496C6.30771 11.2022 6.3413 11.1426 6.35718 11.0773C6.37306 11.012 6.37061 10.9436 6.35011 10.8796L5.95011 9.49962Z"
        fill={fill}
      />
      <path
        d="M20.95 14.5002L21.36 13.1102C21.3782 13.046 21.3794 12.9782 21.3636 12.9134C21.3479 12.8486 21.3156 12.7889 21.27 12.7402C21.2226 12.6926 21.1629 12.659 21.0977 12.6432C21.0324 12.6273 20.964 12.6297 20.9 12.6502L19.51 13.0602L18.12 12.6502C18.0558 12.6321 17.988 12.6308 17.9232 12.6466C17.8583 12.6623 17.7987 12.6946 17.75 12.7402C17.7024 12.7876 17.6688 12.8473 17.6529 12.9126C17.637 12.9778 17.6395 13.0462 17.66 13.1102L18.07 14.5002L17.66 15.8902C17.6418 15.9544 17.6406 16.0222 17.6563 16.0871C17.6721 16.1519 17.7044 16.2115 17.75 16.2602C17.7974 16.3078 17.857 16.3414 17.9223 16.3573C17.9876 16.3732 18.056 16.3707 18.12 16.3502L19.51 15.9402L20.9 16.3502C20.936 16.359 20.973 16.3623 21.01 16.3602C21.1106 16.3588 21.207 16.3196 21.28 16.2502C21.3276 16.2028 21.3612 16.1432 21.3771 16.0779C21.3929 16.0126 21.3905 15.9442 21.37 15.8802L20.95 14.5002Z"
        fill={fill}
      />
    </svg>
  );
};
export const ListFill1 = ({
  fill = "none",
  stroke = "none",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM9.97 14.9L7.72 17.15C7.57 17.3 7.38 17.37 7.19 17.37C7 17.37 6.8 17.3 6.66 17.15L5.91 16.4C5.61 16.11 5.61 15.63 5.91 15.34C6.2 15.05 6.67 15.05 6.97 15.34L7.19 15.56L8.91 13.84C9.2 13.55 9.67 13.55 9.97 13.84C10.26 14.13 10.26 14.61 9.97 14.9ZM9.97 7.9L7.72 10.15C7.57 10.3 7.38 10.37 7.19 10.37C7 10.37 6.8 10.3 6.66 10.15L5.91 9.4C5.61 9.11 5.61 8.63 5.91 8.34C6.2 8.05 6.67 8.05 6.97 8.34L7.19 8.56L8.91 6.84C9.2 6.55 9.67 6.55 9.97 6.84C10.26 7.13 10.26 7.61 9.97 7.9ZM17.56 16.62H12.31C11.9 16.62 11.56 16.28 11.56 15.87C11.56 15.46 11.9 15.12 12.31 15.12H17.56C17.98 15.12 18.31 15.46 18.31 15.87C18.31 16.28 17.98 16.62 17.56 16.62ZM17.56 9.62H12.31C11.9 9.62 11.56 9.28 11.56 8.87C11.56 8.46 11.9 8.12 12.31 8.12H17.56C17.98 8.12 18.31 8.46 18.31 8.87C18.31 9.28 17.98 9.62 17.56 9.62Z"
        fill={fill}
      />
    </svg>
  );
};
export const EditProfile = ({ fill = "none", stroke = "#292d32" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="edit-2" transform="translate(-684 -252)">
        <path
          id="Vector"
          d="M9.263,1.439l-8.21,8.69a3.05,3.05,0,0,0-.67,1.43L.013,14.8a1.527,1.527,0,0,0,1.87,1.77l3.22-.55a2.871,2.871,0,0,0,1.39-.75l8.21-8.69c1.42-1.5,2.06-3.21-.15-5.3C12.353-.791,10.683-.061,9.263,1.439Z"
          transform="translate(687.997 254.161)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0A6.126,6.126,0,0,0,5.45,5.15"
          transform="translate(695.89 257.05)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H18"
          transform="translate(687 274)"
          fill={fill}
          stroke={fill === "none" ? "#292d32" : fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(684 252)"
          fill={fill}
          opacity="0"
        />
      </g>
    </svg>
  );
};
export const NodataIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_29380"
            data-name="Rectangle 29380"
            width="80"
            height="80"
            transform="translate(2906 -1182)"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g
        id="Mask_Group_2630"
        data-name="Mask Group 2630"
        transform="translate(-2906 1182)"
        clipPath="url(#clip-path)"
      >
        <g id="Group_53344" data-name="Group 53344">
          <path
            id="Path_109168"
            data-name="Path 109168"
            d="M29.07,0A29.07,29.07,0,1,1,0,29.07,29.07,29.07,0,0,1,29.07,0Z"
            transform="translate(2917 -1171)"
            fill="#f6f6f6"
          />
          <path
            id="Path_109169"
            data-name="Path 109169"
            d="M3.735,0A3.735,3.735,0,1,1,0,3.735,3.735,3.735,0,0,1,3.735,0Z"
            transform="translate(2912.5 -1165.174)"
            fill="#c0c2c2"
          />
          <path
            id="Path_109170"
            data-name="Path 109170"
            d="M2.948,0A2.948,2.948,0,1,1,0,2.948,2.948,2.948,0,0,1,2.948,0Z"
            transform="translate(2917.088 -1171.07)"
            fill="#c0c2c2"
          />
          <circle
            id="Ellipse_4274"
            data-name="Ellipse 4274"
            cx="3"
            cy="3"
            r="3"
            transform="translate(2966.5 -1119.07)"
            fill="#c0c2c2"
          />
          <circle
            id="Ellipse_4275"
            data-name="Ellipse 4275"
            cx="4"
            cy="4"
            r="4"
            transform="translate(2971.5 -1127.07)"
            fill="#c0c2c2"
          />
          <g
            id="vuesax_bulk_transaction-minus"
            data-name="vuesax/bulk/transaction-minus"
            transform="translate(2626 -1414)"
          >
            <g id="transaction-minus" transform="translate(300 252)">
              <path
                id="Vector"
                d="M0,0H40.154V40.154H0Z"
                fill="none"
                opacity="0"
              />
              <path
                id="Vector-2"
                data-name="Vector"
                d="M5.568,30a3.045,3.045,0,0,1,4.794.254L12.1,32.546a3.01,3.01,0,0,0,5.035,0l1.736-2.288A3.045,3.045,0,0,1,23.663,30c3.059,3.221,5.551,2.153,5.551-2.356V8.543C29.213,1.712,27.6,0,21.1,0H8.111C1.615,0,0,1.712,0,8.543V27.63C.017,32.156,2.526,33.207,5.568,30Z"
                transform="translate(5.455 3.126)"
                fill="#e1e2e2"
              />
              <g id="Group" transform="translate(14.607 15.544)">
                <path
                  id="Vector-3"
                  data-name="Vector"
                  d="M9.769,2.345h-8.6A1.181,1.181,0,0,1,0,1.172,1.181,1.181,0,0,1,1.172,0h8.6a1.181,1.181,0,0,1,1.172,1.172A1.181,1.181,0,0,1,9.769,2.345Z"
                  fill="#127a3e"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export const ViewIcon = ({ fill = "none", stroke = "#fff" }) => {
  return (
    <svg
      id="vuesax_linear_eye"
      data-name="vuesax/linear/eye"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="eye">
        <path
          id="Vector"
          d="M7.16,3.58A3.58,3.58,0,1,1,3.58,0,3.576,3.576,0,0,1,7.16,3.58Z"
          transform="translate(8.42 8.42)"
          fill={fill}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M9.785,16.55c3.53,0,6.82-2.08,9.11-5.68a5.326,5.326,0,0,0,0-5.19C16.6,2.08,13.315,0,9.785,0S2.965,2.08.675,5.68a5.326,5.326,0,0,0,0,5.19C2.965,14.47,6.255,16.55,9.785,16.55Z"
          transform="translate(2.215 3.72)"
          fill="none"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(24 24) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
};

export const Library1 = ({ fill = "none", stroke = "none", width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 43.6151C21.541 41.5331 18.8596 39.917 15.9558 38.767C13.0519 37.617 10.0667 36.9907 7 36.8882V16.9383C10.0436 17.0281 13.0205 17.7768 15.9307 19.1844C18.841 20.5921 21.5308 22.4447 24 24.7421C26.4692 22.4447 29.1589 20.5921 32.0692 19.1844C34.9794 17.7768 37.9563 17.0281 40.9999 16.9383V36.8882C37.9332 36.9907 34.948 37.617 32.0442 38.767C29.1403 39.917 26.4589 41.5331 24 43.6151ZM24.1115 17.1305C22.15 17.1305 20.4916 16.4562 19.1365 15.1075C17.7814 13.7588 17.1039 12.0973 17.1039 10.1229C17.1039 8.16135 17.7814 6.50303 19.1365 5.14793C20.4916 3.7928 22.15 3.11523 24.1115 3.11523C26.073 3.11523 27.7313 3.7928 29.0865 5.14793C30.4416 6.50303 31.1192 8.16135 31.1192 10.1229C31.1192 12.0973 30.4416 13.7588 29.0865 15.1075C27.7313 16.4562 26.073 17.1305 24.1115 17.1305Z"
        fill={fill}
      />
    </svg>
  );
};
export const Location1 = ({
  fill = "none",
  stroke = "none",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0044 23.1346C24.8655 23.1346 25.6025 22.8267 26.2153 22.2109C26.8281 21.5951 27.1346 20.8567 27.1346 19.9955C27.1346 19.1344 26.8267 18.3974 26.2109 17.7846C25.5951 17.1718 24.8567 16.8654 23.9955 16.8654C23.1344 16.8654 22.3974 17.1732 21.7846 17.789C21.1718 18.4048 20.8654 19.1432 20.8654 20.0044C20.8654 20.8655 21.1732 21.6025 21.789 22.2153C22.4048 22.8281 23.1432 23.1346 24.0044 23.1346ZM23.9999 43.6153C18.7872 39.0871 14.9006 34.8839 12.3403 31.0057C9.78012 27.1275 8.5 23.5923 8.5 20.4C8.5 15.5538 10.0602 11.6923 13.1807 8.81535C16.3012 5.93845 19.9076 4.5 23.9999 4.5C28.0923 4.5 31.6986 5.93845 34.8191 8.81535C37.9396 11.6923 39.4999 15.5538 39.4999 20.4C39.4999 23.5923 38.2198 27.1275 35.6596 31.0057C33.0993 34.8839 29.2127 39.0871 23.9999 43.6153Z"
        fill={fill}
      />
    </svg>
  );
};
export const Location2 = ({
  fill = "none",
  stroke = "none",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9999 43.6153C18.7872 39.0871 14.9006 34.8839 12.3403 31.0057C9.78012 27.1275 8.5 23.5923 8.5 20.4C8.5 15.5538 10.0602 11.6923 13.1807 8.81535C16.3012 5.93845 19.9076 4.5 23.9999 4.5C28.0923 4.5 31.6986 5.93845 34.8191 8.81535C37.9396 11.6923 39.4999 15.5538 39.4999 20.4C39.4999 23.5923 38.2198 27.1275 35.6596 31.0057C33.0993 34.8839 29.2127 39.0871 23.9999 43.6153ZM18.8269 25.6537H21.7884V20.173H26.2114V25.6537H29.173V17.0192L23.9999 13.6L18.8269 17.0192V25.6537Z"
        fill={fill}
      />
    </svg>
  );
};
export const BestIcon = ({ fill = "none", stroke = "none" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 9.5C10.25 9.03587 10.4344 8.59075 10.7626 8.26256C11.0908 7.93437 11.5359 7.75 12 7.75C12.4641 7.75 12.9092 7.93437 13.2374 8.26256C13.5656 8.59075 13.75 9.03587 13.75 9.5C13.75 9.96413 13.5656 10.4092 13.2374 10.7374C12.9092 11.0656 12.4641 11.25 12 11.25C11.5359 11.25 11.0908 11.0656 10.7626 10.7374C10.4344 10.4092 10.25 9.96413 10.25 9.5Z"
        fill="#ED9140"
      />
      <path
        d="M4.99999 9.49967C5.00019 8.41463 5.25263 7.3445 5.73736 6.37376C6.22209 5.40302 6.92586 4.55826 7.79308 3.90617C8.6603 3.25407 9.66725 2.81251 10.7344 2.61634C11.8016 2.42016 12.8997 2.47475 13.9421 2.7758C14.9846 3.07684 15.9428 3.61609 16.741 4.35098C17.5393 5.08586 18.1558 5.99626 18.5419 7.01029C18.928 8.02431 19.073 9.11421 18.9656 10.1939C18.8582 11.2736 18.5013 12.3136 17.923 13.2317L20.65 17.9547C20.7219 18.0795 20.7563 18.2224 20.7492 18.3663C20.742 18.5102 20.6936 18.649 20.6096 18.7661C20.5256 18.8832 20.4097 18.9736 20.2757 19.0266C20.1417 19.0795 19.9953 19.0927 19.854 19.0647L17.238 18.5447L16.38 21.0707C16.3337 21.2073 16.249 21.3276 16.1361 21.4173C16.0231 21.507 15.8867 21.5622 15.7432 21.5763C15.5997 21.5905 15.4551 21.5629 15.3269 21.497C15.1986 21.4311 15.092 21.3296 15.02 21.2047L12.3 16.4937C12.1001 16.5021 11.8999 16.5021 11.7 16.4937L8.97999 21.2047C8.9081 21.3296 8.80171 21.4312 8.67356 21.4973C8.54541 21.5634 8.40093 21.5911 8.25743 21.5772C8.11393 21.5633 7.97748 21.5083 7.86443 21.4188C7.75137 21.3293 7.66651 21.2091 7.61999 21.0727L6.75899 18.5527L4.14499 19.0657C4.00375 19.0935 3.85748 19.0801 3.72365 19.027C3.58982 18.974 3.47408 18.8836 3.39026 18.7665C3.30643 18.6495 3.25806 18.5108 3.25092 18.367C3.24378 18.2232 3.27817 18.0804 3.34999 17.9557L6.07699 13.2327C5.37127 12.1156 4.99775 10.821 4.99999 9.49967ZM7.08599 14.4847C7.92964 15.3178 8.97127 15.9228 10.113 16.2427L8.50599 19.0257L7.96599 17.4467C7.90726 17.2752 7.7884 17.1307 7.6314 17.0401C7.4744 16.9495 7.28988 16.9188 7.11199 16.9537L5.47499 17.2757L7.08499 14.4857L7.08599 14.4847ZM13.887 16.2427L15.492 19.0217L16.029 17.4407C16.0874 17.2684 16.2064 17.1232 16.3639 17.0321C16.5213 16.9411 16.7065 16.9103 16.885 16.9457L18.523 17.2717L16.914 14.4847C16.0703 15.3178 15.0287 15.9227 13.887 16.2427ZM12 6.24967C11.138 6.24967 10.3114 6.59208 9.70189 7.20157C9.0924 7.81107 8.74999 8.63772 8.74999 9.49967C8.74999 10.3616 9.0924 11.1883 9.70189 11.7978C10.3114 12.4073 11.138 12.7497 12 12.7497C12.8619 12.7497 13.6886 12.4073 14.2981 11.7978C14.9076 11.1883 15.25 10.3616 15.25 9.49967C15.25 8.63772 14.9076 7.81107 14.2981 7.20157C13.6886 6.59208 12.8619 6.24967 12 6.24967Z"
        fill="#ED9140"
      />
    </svg>
  );
};

export const FeatIcon = ({ fill = "none", stroke = "none" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8653 2.99627C12.7774 2.84474 12.6512 2.71895 12.4994 2.63151C12.3476 2.54407 12.1755 2.49805 12.0003 2.49805C11.8251 2.49805 11.653 2.54407 11.5012 2.63151C11.3494 2.71895 11.2232 2.84474 11.1353 2.99627L8.42131 7.67427C8.32731 7.83607 8.19818 7.9747 8.04345 8.07993C7.88872 8.18516 7.71233 8.25431 7.52731 8.28227L2.44031 9.05027C1.58631 9.18027 1.28631 10.2583 1.95231 10.8103L5.74131 13.9483C6.09131 14.2393 6.25631 14.6983 6.17131 15.1453L5.18031 20.3503C5.14512 20.5351 5.1628 20.7262 5.23132 20.9014C5.29983 21.0767 5.41641 21.2291 5.56765 21.341C5.71889 21.453 5.89865 21.52 6.08628 21.5344C6.27391 21.5488 6.46178 21.5099 6.62831 21.4223L11.4183 18.9003C11.5978 18.8059 11.7975 18.7565 12.0003 18.7565C12.2031 18.7565 12.4028 18.8059 12.5823 18.9003L17.3723 21.4223C17.5388 21.5099 17.7267 21.5488 17.9143 21.5344C18.102 21.52 18.2817 21.453 18.433 21.341C18.5842 21.2291 18.7008 21.0767 18.7693 20.9014C18.8378 20.7262 18.8555 20.5351 18.8203 20.3503L17.8293 15.1453C17.7873 14.9255 17.8051 14.6985 17.8807 14.488C17.9563 14.2774 18.0871 14.0911 18.2593 13.9483L22.0493 10.8093C22.7143 10.2593 22.4143 9.17928 21.5593 9.05027L16.4743 8.28227C16.2891 8.25445 16.1125 8.18537 15.9576 8.08013C15.8027 7.97489 15.6734 7.83619 15.5793 7.67427L12.8653 2.99627Z"
        fill="#ED9140"
      />
    </svg>
  );
};

export const RealPropertyIcon = ({ fill = "none", stroke = "none" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path
          fill={fill}
          stroke={stroke}
          // style=" stroke:none;fill-rule:nonzero;fill:rgb(14.117647%,68.235294%,37.254902%);fill-opacity:1;"
          d="M 6.621094 4.136719 L 6.621094 1.65625 L 7.449219 1.65625 L 7.449219 0 L 2.484375 0 L 2.484375 1.65625 L 3.308594 1.65625 L 3.308594 7.035156 L 0.992188 9.019531 C 0.664062 9.351562 0.867188 9.929688 1.324219 9.929688 L 3.308594 9.929688 L 3.308594 22.34375 L 2.484375 22.34375 L 2.484375 24 L 21.515625 24 L 21.515625 22.34375 L 20.691406 22.34375 L 20.691406 9.929688 L 22.675781 9.929688 C 23.132812 9.929688 23.339844 9.351562 23.007812 9.0625 L 13.488281 0.621094 C 12.660156 -0.164062 11.339844 -0.164062 10.511719 0.621094 Z M 6.621094 4.136719 "
        />
        <path
          fill="#fff"
          // style=" stroke:none;fill-rule:nonzero;fill:rgb(92.54902%,94.509804%,94.509804%);fill-opacity:1;"
          d="M 18.785156 19.695312 L 14.316406 15.226562 C 14.9375 14.441406 15.308594 13.488281 15.308594 12.414062 C 15.308594 9.890625 13.28125 7.863281 10.757812 7.863281 C 8.234375 7.863281 6.207031 9.890625 6.207031 12.414062 C 6.207031 14.9375 8.234375 16.964844 10.757812 16.964844 C 11.628906 16.964844 12.414062 16.71875 13.074219 16.304688 L 17.628906 20.855469 Z M 18.785156 19.695312 "
        />
        <path
          fill={fill}
          // style=" stroke:none;fill-rule:nonzero;fill:rgb(49.019608%,75.294118%,87.843137%);fill-opacity:1;"
          d="M 10.757812 15.308594 C 9.144531 15.308594 7.863281 14.027344 7.863281 12.414062 C 7.863281 10.800781 9.144531 9.515625 10.757812 9.515625 C 12.371094 9.515625 13.65625 10.800781 13.65625 12.414062 C 13.65625 14.027344 12.371094 15.308594 10.757812 15.308594 "
        />
      </g>
    </svg>
  );
};

export const SocialMediaInsightIcon = ({ fill = "none", stroke = "none" }) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 22 22"
      fill={fill}
      stroke={stroke}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96388 12.4302C7.43428 11.8334 7.71504 11.08 7.71504 10.2611C7.71504 8.32443 6.14505 6.75445 4.20835 6.75445C2.27164 6.75445 0.70166 8.32443 0.70166 10.2611C0.70166 12.1978 2.27164 13.7678 4.20835 13.7678C5.05382 13.7678 5.82936 13.4686 6.43497 12.9703C6.44348 12.9633 6.45428 12.9596 6.46532 12.96C6.47636 12.9604 6.48686 12.9649 6.49483 12.9725L7.90233 14.316C7.90682 14.3202 7.91039 14.3252 7.91279 14.3309C7.9152 14.3365 7.9164 14.3426 7.9163 14.3487V15.9186C7.9163 15.9346 7.92393 15.9484 7.93752 15.9569C7.9511 15.9654 7.96684 15.9662 7.9812 15.9591L8.5654 15.6741C8.57308 15.6705 8.57955 15.6648 8.58404 15.6576C8.58854 15.6504 8.59086 15.6421 8.59075 15.6336V14.1844C8.59075 14.0883 8.55052 14.0015 8.48596 13.9401L8.4863 13.9398L6.96825 12.4907C6.96007 12.483 6.95507 12.4725 6.95427 12.4613C6.95346 12.4501 6.95689 12.439 6.96388 12.4302ZM5.2714 21.3324V16.4307C5.27115 16.4216 5.26742 16.4129 5.26097 16.4064C5.25453 16.4 5.24586 16.3963 5.23675 16.396H4.08432C4.07521 16.3963 4.06654 16.4 4.06009 16.4064C4.05365 16.4129 4.04991 16.4216 4.04966 16.4307V21.3324C4.04966 21.3508 4.06593 21.3671 4.08432 21.3671H5.23675C5.24586 21.3668 5.25454 21.3631 5.26098 21.3567C5.26743 21.3502 5.27116 21.3415 5.2714 21.3324ZM7.37577 16.848C7.70236 16.7763 8.32166 16.4749 8.90971 16.1928C9.913 15.7114 10.1667 15.6577 10.8581 15.7916C10.8612 15.7921 10.8643 15.7931 10.8672 15.7944C10.9079 15.8117 10.9516 15.8209 10.9958 15.8215C10.9988 15.8215 11.0017 15.8218 11.0046 15.8224L11.2925 15.8832C11.7925 15.9922 13.5392 16.3171 13.5392 16.8703C13.5392 16.9605 13.5363 17.0108 13.5076 17.1003C13.4617 17.2437 13.4513 17.2138 13.3981 17.2733C13.239 17.4513 13.0078 17.5439 12.7639 17.5244L9.80889 17.2869C9.72048 17.2818 9.63358 17.3115 9.56684 17.3697C9.5001 17.4279 9.45884 17.51 9.45192 17.5983C9.44499 17.6866 9.47296 17.774 9.52981 17.8419C9.58666 17.9098 9.66787 17.9527 9.756 17.9614L12.711 18.1988C12.938 18.2171 13.1592 18.1804 13.3605 18.1002C13.525 18.0346 13.6761 17.9394 13.8062 17.8191C13.8096 17.8159 13.8135 17.8133 13.8178 17.8114C13.8291 17.806 13.8402 17.8001 13.8509 17.7935L17.5334 15.6555C17.7258 15.5438 17.9481 15.5191 18.1514 15.5691C18.8462 15.7404 18.9786 16.6313 18.3687 16.9896C16.5714 18.0457 12.4719 20.6304 11.4462 20.5714C9.61843 20.4663 7.79112 20.1335 6.00009 20.3934C5.99369 20.3944 5.98713 20.394 5.9809 20.3922C5.97467 20.3904 5.96893 20.3872 5.96409 20.3828C5.95912 20.3787 5.95514 20.3734 5.95244 20.3675C5.94974 20.3616 5.94839 20.3552 5.94849 20.3487V17.071C5.94849 17.0471 5.96707 17.0274 5.99097 17.026C6.45571 16.9985 6.92404 16.9471 7.37577 16.848ZM14.2852 10.2611C14.2852 11.08 14.566 11.8333 15.0364 12.4302C15.0434 12.439 15.0468 12.4501 15.046 12.4613C15.0452 12.4725 15.0403 12.483 15.0321 12.4907L13.5324 13.9223C13.5317 13.923 13.5309 13.9237 13.5301 13.9243C13.492 13.956 13.4612 13.9958 13.4402 14.0408C13.4191 14.0857 13.4082 14.1348 13.4083 14.1844V15.8435C13.4083 15.8615 13.4182 15.8769 13.4345 15.8845C13.6385 15.9784 13.8372 16.0925 14.0087 16.2352C14.0225 16.2466 14.0405 16.2489 14.0567 16.2414C14.073 16.2338 14.0827 16.2185 14.0828 16.2006L14.0854 14.3473C14.0853 14.3412 14.0865 14.3352 14.0889 14.3296C14.0913 14.3239 14.0948 14.3189 14.0993 14.3147L15.5055 12.9725C15.5134 12.9648 15.524 12.9604 15.535 12.9599C15.546 12.9595 15.5568 12.9632 15.5653 12.9703C16.1709 13.4685 16.9465 13.7678 17.792 13.7678C19.7287 13.7678 21.2987 12.1978 21.2987 10.2611C21.2987 8.32438 19.7287 6.7544 17.792 6.7544C15.8553 6.7544 14.2852 8.32443 14.2852 10.2611ZM16.3624 11.9027V9.4964C16.3624 9.47154 16.3827 9.45128 16.4075 9.45128H17.0305C17.0554 9.45128 17.0756 9.43102 17.0756 9.40616V8.6191C17.0756 8.31397 17.3253 8.06432 17.6304 8.06432C17.9355 8.06432 18.1852 8.31397 18.1852 8.6191V9.40616C18.1852 9.43102 18.2054 9.45128 18.2303 9.45128H18.6012C19.2878 9.45128 19.8495 10.013 19.8495 10.6996C19.8495 11.3862 19.2878 11.9479 18.6012 11.9479H16.4075C16.3955 11.9478 16.3841 11.943 16.3756 11.9346C16.3672 11.9261 16.3624 11.9146 16.3624 11.9027ZM11.379 7.62608C11.3679 7.62723 11.3576 7.63246 11.3502 7.64076C11.3427 7.64905 11.3386 7.65981 11.3387 7.67096V15.2399C11.3387 15.254 11.3329 15.266 11.322 15.2749C11.3111 15.2838 11.2982 15.287 11.2845 15.2841L11.0566 15.2372L11.0543 15.2368L10.6999 15.1828C10.6892 15.1812 10.6794 15.1758 10.6724 15.1676C10.6654 15.1594 10.6615 15.149 10.6616 15.1382V7.67091C10.6616 7.65977 10.6575 7.64901 10.65 7.64072C10.6426 7.63243 10.6323 7.6272 10.6212 7.62603C8.86276 7.4371 7.49342 5.94843 7.49342 4.13974C7.49342 2.20304 9.0634 0.633057 11.0001 0.633057C12.9368 0.633057 14.5068 2.20304 14.5068 4.13974C14.5068 5.94848 13.1375 7.43715 11.379 7.62608ZM12.9643 4.17886C12.9786 4.17056 12.9868 4.15635 12.9868 4.13979C12.9868 4.12323 12.9786 4.10898 12.9643 4.10072L10.065 2.42682C10.0506 2.41856 10.0342 2.41856 10.0199 2.42682C10.0055 2.43507 9.99729 2.44933 9.99729 2.46589V5.81365C9.99729 5.83021 10.0055 5.84446 10.0199 5.85272C10.0342 5.86098 10.0506 5.86102 10.065 5.85272L12.9643 4.17886ZM4.97347 8.69835C5.5354 8.69835 5.99092 9.15387 5.99092 9.71581C5.99092 10.6322 5.0362 11.6752 4.22692 12.0418C4.2211 12.0446 4.21474 12.046 4.2083 12.046C4.20186 12.046 4.1955 12.0446 4.18968 12.0418C3.3804 11.6752 2.42572 10.6323 2.42572 9.71581C2.42572 9.15387 2.88124 8.69835 3.44318 8.69835C3.58 8.69819 3.71544 8.72572 3.84135 8.77927C3.96725 8.83282 4.08102 8.9113 4.1758 9.00997C4.18464 9.01914 4.19558 9.02379 4.2083 9.02379C4.22102 9.02379 4.23196 9.01914 4.2408 9.00997C4.33558 8.91129 4.44936 8.83281 4.57527 8.77925C4.70119 8.7257 4.83664 8.69818 4.97347 8.69835Z"
        fill="#C9FFDF"
      />
    </svg>
  );
};

export const CalendarMonth = ({
  fill = "#1f1f1f",
  stroke = "none",
  width = "24px",
  height = "24px",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={fill}
    >
      <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
    </svg>
  );
};

export const ChartLineUpIcon = ({
  width = "24",
  height = "24",
  fill = "none",
  stroke = "currentColor",
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21 19.5H3v-15"></path>
      <path d="M19.5 6 12 13.5l-3-3-6 6"></path>
      <path d="M19.5 9.75V6h-3.75"></path>
    </svg>
  );
};

export const ArrowDownCaret = ({
  width = "20",
  height = "20",
  fill = "none",
  stroke = "#6A6A6A",
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.5 9 12 16.5 4.5 9"></path>
    </svg>
  );
};

export const PlusIcon = ({
  width = "24",
  height = "24",
  fill = "none",
  stroke = "currentColor",
  strokeWidth = "1.5",
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.75 12h16.5"></path>
      <path d="M12 3.75v16.5"></path>
    </svg>
  );
};

export const EyeIcon = ({ width = "24", height = "24", fill = "none" }) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 5.25C4.5 5.25 1.5 12 1.5 12s3 6.75 10.5 6.75S22.5 12 22.5 12s-3-6.75-10.5-6.75Z"></path>
      <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path>
    </svg>
  );
};

export const WarningCircleIcon = ({
  width = "24",
  height = "24",
  fill = "currentColor",
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2.25A9.75 9.75 0 1 0 21.75 12 9.769 9.769 0 0 0 12 2.25Zm-.75 5.25a.75.75 0 1 1 1.5 0v5.25a.75.75 0 1 1-1.5 0V7.5Zm.75 9.75A1.125 1.125 0 1 1 12 15a1.125 1.125 0 0 1 0 2.25Z"></path>
    </svg>
  );
};

export const GlobeIcon = ({
  width = "24",
  height = "24",
  fill = "none",
  stroke = "currentColor",
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"></path>
      <path d="M3.516 9h16.968"></path>
      <path d="M3.516 15h16.968"></path>
      <path d="M12 20.755c2.071 0 3.75-3.92 3.75-8.757 0-4.836-1.679-8.756-3.75-8.756-2.071 0-3.75 3.92-3.75 8.756s1.679 8.757 3.75 8.757Z"></path>
    </svg>
  );
};

export const EditIcon = ({
  color = "#292C2F",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1369 3.46983C14.9963 3.32938 14.8057 3.25049 14.6069 3.25049C14.4082 3.25049 14.2176 3.32938 14.0769 3.46983L4.88395 12.6618C4.78996 12.7559 4.72266 12.8732 4.68895 13.0018L3.68895 16.8318C3.65594 16.9584 3.6566 17.0914 3.69088 17.2176C3.72516 17.3439 3.79185 17.4589 3.88434 17.5514C3.97684 17.6439 4.09191 17.7106 4.21814 17.7449C4.34438 17.7792 4.47738 17.7798 4.60395 17.7468L8.43195 16.7468C8.56103 16.713 8.67874 16.6453 8.77295 16.5508L17.9649 7.35883C18.1054 7.2182 18.1843 7.02758 18.1843 6.82883C18.1843 6.63008 18.1054 6.43945 17.9649 6.29883L15.1369 3.46983ZM6.08795 13.5788L14.6069 5.06083L16.374 6.82783L7.85595 15.3468L5.46295 15.9718L6.08795 13.5788Z"
        fill={color}
      />
      <path
        d="M4 19.25C3.80109 19.25 3.61032 19.329 3.46967 19.4697C3.32902 19.6103 3.25 19.8011 3.25 20C3.25 20.1989 3.32902 20.3897 3.46967 20.5303C3.61032 20.671 3.80109 20.75 4 20.75H19C19.1989 20.75 19.3897 20.671 19.5303 20.5303C19.671 20.3897 19.75 20.1989 19.75 20C19.75 19.8011 19.671 19.6103 19.5303 19.4697C19.3897 19.329 19.1989 19.25 19 19.25H4Z"
        fill={color}
      />
    </svg>
  );
};

export const ViewsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15Z"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExportIcon = () => {
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.625 7.5H12.75V14.6892L15.2198 12.2198C15.3616 12.0851 15.5505 12.0111 15.746 12.0136C15.9416 12.0161 16.1285 12.0949 16.2668 12.2332C16.4051 12.3715 16.4839 12.5584 16.4864 12.754C16.4889 12.9495 16.4149 13.1384 16.2802 13.2802L12.5302 17.0302C12.3895 17.1707 12.1988 17.2497 12 17.2497C11.8012 17.2497 11.6105 17.1707 11.4698 17.0302L7.71984 13.2802C7.58513 13.1384 7.51114 12.9495 7.51364 12.754C7.51614 12.5584 7.59495 12.3715 7.73325 12.2332C7.87155 12.0949 8.0584 12.0161 8.25398 12.0136C8.44955 12.0111 8.63836 12.0851 8.78016 12.2198L11.25 14.6892V7.5H6.375C5.67904 7.50074 5.01179 7.77754 4.51967 8.26967C4.02755 8.76179 3.75074 9.42904 3.75 10.125V19.875C3.75074 20.571 4.02755 21.2382 4.51967 21.7303C5.01179 22.2225 5.67904 22.4993 6.375 22.5H17.625C18.321 22.4993 18.9882 22.2225 19.4803 21.7303C19.9725 21.2382 20.2493 20.571 20.25 19.875V10.125C20.2493 9.42904 19.9725 8.76179 19.4803 8.26967C18.9882 7.77754 18.321 7.50074 17.625 7.5Z"
      fill="#031226"
    />
    <path
      d="M12.75 2.25C12.75 2.05109 12.671 1.86032 12.5303 1.71967C12.3897 1.57902 12.1989 1.5 12 1.5C11.8011 1.5 11.6103 1.57902 11.4697 1.71967C11.329 1.86032 11.25 2.05109 11.25 2.25V7.5H12.75V2.25Z"
      fill="#031226"
    />
  </svg>;
};

export const PhoneIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83704 9.58412C6.60875 11.1779 7.8974 12.4633 9.49304 13.2311C9.61075 13.2865 9.74085 13.3104 9.87057 13.3004C10.0003 13.2904 10.1252 13.2469 10.233 13.1741L12.578 11.6091C12.6815 11.5389 12.801 11.496 12.9255 11.4844C13.05 11.4729 13.1754 11.4931 13.29 11.5431L17.677 13.4271C17.8272 13.4895 17.9527 13.5996 18.034 13.7404C18.1153 13.8812 18.148 14.0449 18.127 14.2061C17.988 15.2914 17.4582 16.2888 16.637 17.0118C15.8157 17.7348 14.7592 18.1338 13.665 18.1341C10.2835 18.1341 7.04052 16.7908 4.64943 14.3997C2.25834 12.0086 0.915039 8.76563 0.915039 5.38412C0.91516 4.2898 1.31404 3.23302 2.03704 2.41155C2.76003 1.59008 3.7576 1.06022 4.84304 0.921116C5.00413 0.900344 5.16758 0.93315 5.30818 1.01447C5.44878 1.0958 5.55872 1.22112 5.62104 1.37112L7.50604 5.76812C7.55491 5.88099 7.57527 6.00414 7.56533 6.12673C7.55539 6.24933 7.51546 6.36759 7.44904 6.47112L5.88504 8.85412C5.81554 8.96166 5.77473 9.08521 5.7665 9.213C5.75828 9.34078 5.7829 9.46854 5.83804 9.58412H5.83704Z"
        stroke="black"
        strokeWidth="1.83"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SmsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 5.25L12 13.5L3 5.25"
        stroke="black"
        strokeWidth="1.83"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z"
        stroke="black"
        strokeWidth="1.83"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3599 12L3.23389 18.534"
        stroke="black"
        strokeWidth="1.83"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7661 18.534L13.6401 12"
        stroke="black"
        strokeWidth="1.83"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1003 5.39985C10.3932 5.69274 10.3932 6.16761 10.1003 6.46051L4.56066 12.0002L10.1003 17.5398C10.3932 17.8327 10.3932 18.3076 10.1003 18.6005C9.80744 18.8934 9.33256 18.8934 9.03967 18.6005L2.96967 12.5305C2.82902 12.3899 2.75 12.1991 2.75 12.0002C2.75 11.8013 2.82902 11.6105 2.96967 11.4698L9.03967 5.39985C9.33256 5.10695 9.80744 5.10695 10.1003 5.39985Z"
        fill="#292C2F"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.91992 12C2.91992 11.5858 3.25571 11.25 3.66992 11.25H20.4999C20.9141 11.25 21.2499 11.5858 21.2499 12C21.2499 12.4142 20.9141 12.75 20.4999 12.75H3.66992C3.25571 12.75 2.91992 12.4142 2.91992 12Z"
        fill="#292C2F"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalenderIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 5.99993C22.5 5.20428 22.1839 4.44122 21.6213 3.87861C21.0587 3.316 20.2956 2.99993 19.5 2.99993H18.75V2.27103C18.75 1.86743 18.4397 1.52103 18.0361 1.50087C17.9347 1.49598 17.8333 1.51174 17.7382 1.54717C17.6431 1.58261 17.5561 1.637 17.4826 1.70704C17.4091 1.77707 17.3506 1.8613 17.3106 1.95462C17.2706 2.04794 17.25 2.14841 17.25 2.24993V2.99993H6.75V2.27103C6.75 1.86743 6.43969 1.52103 6.03609 1.50087C5.93469 1.49598 5.83334 1.51174 5.7382 1.54717C5.64307 1.58261 5.55611 1.637 5.48261 1.70704C5.40911 1.77707 5.3506 1.8613 5.31062 1.95462C5.27063 2.04794 5.25001 2.14841 5.25 2.24993V2.99993H4.5C3.70435 2.99993 2.94129 3.316 2.37868 3.87861C1.81607 4.44122 1.5 5.20428 1.5 5.99993V6.56243C1.5 6.61216 1.51975 6.65985 1.55492 6.69502C1.59008 6.73018 1.63777 6.74994 1.6875 6.74994H22.3125C22.3622 6.74994 22.4099 6.73018 22.4451 6.69502C22.4802 6.65985 22.5 6.61216 22.5 6.56243V5.99993Z"
        fill="#031226"
      />
      <path
        d="M1.5 19.5C1.5 20.2956 1.81607 21.0587 2.37868 21.6213C2.94129 22.1839 3.70435 22.5 4.5 22.5H19.5C20.2956 22.5 21.0587 22.1839 21.6213 21.6213C22.1839 21.0587 22.5 20.2956 22.5 19.5V8.39062C22.5 8.35333 22.4852 8.31756 22.4588 8.29119C22.4324 8.26482 22.3967 8.25 22.3594 8.25H1.64062C1.60333 8.25 1.56756 8.26482 1.54119 8.29119C1.51482 8.31756 1.5 8.35333 1.5 8.39062V19.5ZM17.625 9.75C17.8475 9.75 18.065 9.81598 18.25 9.9396C18.435 10.0632 18.5792 10.2389 18.6644 10.4445C18.7495 10.65 18.7718 10.8762 18.7284 11.0945C18.685 11.3127 18.5778 11.5132 18.4205 11.6705C18.2632 11.8278 18.0627 11.935 17.8445 11.9784C17.6262 12.0218 17.4 11.9995 17.1945 11.9144C16.9889 11.8292 16.8132 11.685 16.6896 11.5C16.566 11.315 16.5 11.0975 16.5 10.875C16.5 10.5766 16.6185 10.2905 16.8295 10.0795C17.0405 9.86853 17.3266 9.75 17.625 9.75ZM17.625 13.5C17.8475 13.5 18.065 13.566 18.25 13.6896C18.435 13.8132 18.5792 13.9889 18.6644 14.1945C18.7495 14.4 18.7718 14.6262 18.7284 14.8445C18.685 15.0627 18.5778 15.2632 18.4205 15.4205C18.2632 15.5778 18.0627 15.685 17.8445 15.7284C17.6262 15.7718 17.4 15.7495 17.1945 15.6644C16.9889 15.5792 16.8132 15.435 16.6896 15.25C16.566 15.065 16.5 14.8475 16.5 14.625C16.5 14.3266 16.6185 14.0405 16.8295 13.8295C17.0405 13.6185 17.3266 13.5 17.625 13.5ZM13.875 9.75C14.0975 9.75 14.315 9.81598 14.5 9.9396C14.685 10.0632 14.8292 10.2389 14.9144 10.4445C14.9995 10.65 15.0218 10.8762 14.9784 11.0945C14.935 11.3127 14.8278 11.5132 14.6705 11.6705C14.5132 11.8278 14.3127 11.935 14.0945 11.9784C13.8762 12.0218 13.65 11.9995 13.4445 11.9144C13.2389 11.8292 13.0632 11.685 12.9396 11.5C12.816 11.315 12.75 11.0975 12.75 10.875C12.75 10.5766 12.8685 10.2905 13.0795 10.0795C13.2905 9.86853 13.5766 9.75 13.875 9.75ZM13.875 13.5C14.0975 13.5 14.315 13.566 14.5 13.6896C14.685 13.8132 14.8292 13.9889 14.9144 14.1945C14.9995 14.4 15.0218 14.6262 14.9784 14.8445C14.935 15.0627 14.8278 15.2632 14.6705 15.4205C14.5132 15.5778 14.3127 15.685 14.0945 15.7284C13.8762 15.7718 13.65 15.7495 13.4445 15.6644C13.2389 15.5792 13.0632 15.435 12.9396 15.25C12.816 15.065 12.75 14.8475 12.75 14.625C12.75 14.3266 12.8685 14.0405 13.0795 13.8295C13.2905 13.6185 13.5766 13.5 13.875 13.5ZM13.875 17.25C14.0975 17.25 14.315 17.316 14.5 17.4396C14.685 17.5632 14.8292 17.7389 14.9144 17.9445C14.9995 18.15 15.0218 18.3762 14.9784 18.5945C14.935 18.8127 14.8278 19.0132 14.6705 19.1705C14.5132 19.3278 14.3127 19.435 14.0945 19.4784C13.8762 19.5218 13.65 19.4995 13.4445 19.4144C13.2389 19.3292 13.0632 19.185 12.9396 19C12.816 18.815 12.75 18.5975 12.75 18.375C12.75 18.0766 12.8685 17.7905 13.0795 17.5795C13.2905 17.3685 13.5766 17.25 13.875 17.25ZM10.125 13.5C10.3475 13.5 10.565 13.566 10.75 13.6896C10.935 13.8132 11.0792 13.9889 11.1644 14.1945C11.2495 14.4 11.2718 14.6262 11.2284 14.8445C11.185 15.0627 11.0778 15.2632 10.9205 15.4205C10.7632 15.5778 10.5627 15.685 10.3445 15.7284C10.1262 15.7718 9.90005 15.7495 9.69448 15.6644C9.48891 15.5792 9.31321 15.435 9.1896 15.25C9.06598 15.065 9 14.8475 9 14.625C9 14.3266 9.11853 14.0405 9.3295 13.8295C9.54048 13.6185 9.82663 13.5 10.125 13.5ZM10.125 17.25C10.3475 17.25 10.565 17.316 10.75 17.4396C10.935 17.5632 11.0792 17.7389 11.1644 17.9445C11.2495 18.15 11.2718 18.3762 11.2284 18.5945C11.185 18.8127 11.0778 19.0132 10.9205 19.1705C10.7632 19.3278 10.5627 19.435 10.3445 19.4784C10.1262 19.5218 9.90005 19.4995 9.69448 19.4144C9.48891 19.3292 9.31321 19.185 9.1896 19C9.06598 18.815 9 18.5975 9 18.375C9 18.0766 9.11853 17.7905 9.3295 17.5795C9.54048 17.3685 9.82663 17.25 10.125 17.25ZM6.375 13.5C6.5975 13.5 6.81501 13.566 7.00002 13.6896C7.18502 13.8132 7.32922 13.9889 7.41436 14.1945C7.49951 14.4 7.52179 14.6262 7.47838 14.8445C7.43498 15.0627 7.32783 15.2632 7.1705 15.4205C7.01316 15.5778 6.81271 15.685 6.59448 15.7284C6.37625 15.7718 6.15005 15.7495 5.94448 15.6644C5.73891 15.5792 5.56321 15.435 5.4396 15.25C5.31598 15.065 5.25 14.8475 5.25 14.625C5.25 14.3266 5.36853 14.0405 5.5795 13.8295C5.79048 13.6185 6.07663 13.5 6.375 13.5ZM6.375 17.25C6.5975 17.25 6.81501 17.316 7.00002 17.4396C7.18502 17.5632 7.32922 17.7389 7.41436 17.9445C7.49951 18.15 7.52179 18.3762 7.47838 18.5945C7.43498 18.8127 7.32783 19.0132 7.1705 19.1705C7.01316 19.3278 6.81271 19.435 6.59448 19.4784C6.37625 19.5218 6.15005 19.4995 5.94448 19.4144C5.73891 19.3292 5.56321 19.185 5.4396 19C5.31598 18.815 5.25 18.5975 5.25 18.375C5.25 18.0766 5.36853 17.7905 5.5795 17.5795C5.79048 17.3685 6.07663 17.25 6.375 17.25Z"
        fill="#031226"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.422 4.64001C21.3052 4.37451 21.1135 4.14888 20.8703 3.99078C20.6271 3.83269 20.3431 3.74901 20.053 3.75001H3.94702C3.65694 3.75226 3.37365 3.83802 3.13103 3.99703C2.88841 4.15604 2.69672 4.38157 2.5789 4.64664C2.46107 4.91172 2.4221 5.20513 2.46663 5.49177C2.51116 5.77842 2.63732 6.04617 2.83002 6.26301L9.00002 13.04V20.352C8.99947 20.6241 9.07347 20.8912 9.21397 21.1243C9.35447 21.3573 9.55611 21.5474 9.79702 21.674C10.014 21.789 10.255 21.85 10.5 21.852C10.7969 21.8521 11.0872 21.764 11.334 21.599L14.334 19.593C14.5394 19.4566 14.7077 19.2713 14.824 19.0539C14.9402 18.8365 15.0007 18.5936 15 18.347V13.04L21.169 6.26201C21.3654 6.04613 21.4941 5.77734 21.539 5.48899C21.584 5.20065 21.5433 4.90544 21.422 4.64001Z"
        fill="#292C2F"
      />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 11.25H3.75C3.55109 11.25 3.36032 11.329 3.21967 11.4697C3.07902 11.6103 3 11.8011 3 12C3 12.1989 3.07902 12.3897 3.21967 12.5303C3.36032 12.671 3.55109 12.75 3.75 12.75H20.25C20.4489 12.75 20.6397 12.671 20.7803 12.5303C20.921 12.3897 21 12.1989 21 12C21 11.8011 20.921 11.6103 20.7803 11.4697C20.6397 11.329 20.4489 11.25 20.25 11.25Z"
        fill="#292C2F"
      />
      <path
        d="M3.75 6.75H20.25C20.4489 6.75 20.6397 6.67098 20.7803 6.53033C20.921 6.38968 21 6.19891 21 6C21 5.80109 20.921 5.61032 20.7803 5.46967C20.6397 5.32902 20.4489 5.25 20.25 5.25H3.75C3.55109 5.25 3.36032 5.32902 3.21967 5.46967C3.07902 5.61032 3 5.80109 3 6C3 6.19891 3.07902 6.38968 3.21967 6.53033C3.36032 6.67098 3.55109 6.75 3.75 6.75Z"
        fill="#292C2F"
      />
      <path
        d="M20.25 17.25H3.75C3.55109 17.25 3.36032 17.329 3.21967 17.4697C3.07902 17.6103 3 17.8011 3 18C3 18.1989 3.07902 18.3897 3.21967 18.5303C3.36032 18.671 3.55109 18.75 3.75 18.75H20.25C20.4489 18.75 20.6397 18.671 20.7803 18.5303C20.921 18.3897 21 18.1989 21 18C21 17.8011 20.921 17.6103 20.7803 17.4697C20.6397 17.329 20.4489 17.25 20.25 17.25Z"
        fill="#292C2F"
      />
    </svg>
  );
};

export const GridIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.125 3.375H4.875C4.47718 3.375 4.09564 3.53304 3.81434 3.81434C3.53304 4.09564 3.375 4.47718 3.375 4.875V19.125C3.375 19.5228 3.53304 19.9044 3.81434 20.1857C4.09564 20.467 4.47718 20.625 4.875 20.625H19.125C19.5228 20.625 19.9044 20.467 20.1857 20.1857C20.467 19.9044 20.625 19.5228 20.625 19.125V4.875C20.625 4.47718 20.467 4.09564 20.1857 3.81434C19.9044 3.53304 19.5228 3.375 19.125 3.375ZM19.125 12H12V4.875H19.125V12ZM4.875 12H12V19.125H4.875V12Z"
        fill="#003022"
      />
    </svg>
  );
};

export const ArrowUpRightIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8738 2.38334C12.7379 1.24602 11.2902 0.471188 9.71383 0.156864C8.13745 -0.157461 6.50327 0.00285079 5.01803 0.617516C3.53279 1.23218 2.26325 2.27358 1.37001 3.60994C0.476778 4.94631 0 6.5176 0 8.125C0 9.73241 0.476778 11.3037 1.37001 12.6401C2.26325 13.9764 3.53279 15.0178 5.01803 15.6325C6.50327 16.2472 8.13745 16.4075 9.71383 16.0931C11.2902 15.7788 12.7379 15.004 13.8738 13.8667C14.6282 13.1129 15.2267 12.2178 15.635 11.2326C16.0433 10.2474 16.2535 9.19145 16.2535 8.125C16.2535 7.05856 16.0433 6.00256 15.635 5.01738C15.2267 4.03219 14.6282 3.13712 13.8738 2.38334ZM10.9446 9.6875C10.9446 9.85326 10.8788 10.0122 10.7616 10.1294C10.6444 10.2467 10.4854 10.3125 10.3196 10.3125C10.1539 10.3125 9.99492 10.2467 9.87771 10.1294C9.7605 10.0122 9.69465 9.85326 9.69465 9.6875V7.44584L6.38965 10.7575C6.26894 10.8709 6.11024 10.9351 5.94465 10.9375C5.77861 10.9373 5.61911 10.8728 5.49965 10.7575C5.3826 10.639 5.31697 10.4791 5.31697 10.3125C5.31697 10.1459 5.3826 9.98604 5.49965 9.8675L8.81215 6.5625H6.56965C6.40389 6.5625 6.24492 6.49665 6.12771 6.37945C6.0105 6.26223 5.94465 6.10326 5.94465 5.9375C5.94465 5.77174 6.0105 5.61277 6.12771 5.49556C6.24492 5.37835 6.40389 5.3125 6.56965 5.3125H10.3196C10.4429 5.3132 10.5633 5.34984 10.666 5.41793C10.7687 5.48602 10.8493 5.5826 10.898 5.69584C10.9285 5.77278 10.9443 5.85474 10.9446 5.9375V9.6875Z"
        fill="#292C2F"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 4.5H16.5V3.75C16.4974 3.15407 16.2595 2.5833 15.8381 2.16192C15.4167 1.74053 14.8459 1.50263 14.25 1.5H9.75C9.15407 1.50263 8.5833 1.74053 8.16192 2.16192C7.74053 2.5833 7.50263 3.15407 7.5 3.75V4.5H3.75C3.55109 4.5 3.36032 4.57902 3.21967 4.71967C3.07902 4.86032 3 5.05109 3 5.25C3 5.44891 3.07902 5.63968 3.21967 5.78033C3.36032 5.92098 3.55109 6 3.75 6H4.5V19.5C4.5 19.8978 4.65804 20.2794 4.93934 20.5607C5.22064 20.842 5.60218 21 6 21H18C18.3978 21 18.7794 20.842 19.0607 20.5607C19.342 20.2794 19.5 19.8978 19.5 19.5V6H20.25C20.4489 6 20.6397 5.92098 20.7803 5.78033C20.921 5.63968 21 5.44891 21 5.25C21 5.05109 20.921 4.86032 20.7803 4.71967C20.6397 4.57902 20.4489 4.5 20.25 4.5ZM10.5 15.75C10.5 15.9489 10.421 16.1397 10.2803 16.2803C10.1397 16.421 9.94891 16.5 9.75 16.5C9.55109 16.5 9.36032 16.421 9.21967 16.2803C9.07902 16.1397 9 15.9489 9 15.75V9.75C9 9.55109 9.07902 9.36032 9.21967 9.21967C9.36032 9.07902 9.55109 9 9.75 9C9.94891 9 10.1397 9.07902 10.2803 9.21967C10.421 9.36032 10.5 9.55109 10.5 9.75V15.75ZM15 15.75C15 15.9489 14.921 16.1397 14.7803 16.2803C14.6397 16.421 14.4489 16.5 14.25 16.5C14.0511 16.5 13.8603 16.421 13.7197 16.2803C13.579 16.1397 13.5 15.9489 13.5 15.75V9.75C13.5 9.55109 13.579 9.36032 13.7197 9.21967C13.8603 9.07902 14.0511 9 14.25 9C14.4489 9 14.6397 9.07902 14.7803 9.21967C14.921 9.36032 15 9.55109 15 9.75V15.75ZM15 4.5H9V3.75C9 3.55109 9.07902 3.36032 9.21967 3.21967C9.36032 3.07902 9.55109 3 9.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75V4.5Z"
        fill="#003022"
      />
    </svg>
  );
};

export const CalenderDateIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 3.125H3.75C3.58424 3.125 3.42527 3.19085 3.30806 3.30806C3.19085 3.42527 3.125 3.58424 3.125 3.75V16.25C3.125 16.595 3.405 16.875 3.75 16.875H16.25C16.4158 16.875 16.5747 16.8092 16.6919 16.6919C16.8092 16.5747 16.875 16.4158 16.875 16.25V3.75C16.875 3.58424 16.8092 3.42527 16.6919 3.30806C16.5747 3.19085 16.4158 3.125 16.25 3.125Z"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 1.5625V3.125"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 1.5625V3.125"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 6.875H16.875"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 10H9.0625L7.8125 11.5625C8.01814 11.5623 8.22065 11.6129 8.40208 11.7097C8.58351 11.8065 8.73825 11.9466 8.85259 12.1175C8.96692 12.2884 9.03732 12.4849 9.05754 12.6896C9.07776 12.8942 9.04718 13.1007 8.96851 13.2907C8.88984 13.4807 8.76551 13.6484 8.60653 13.7788C8.44756 13.9093 8.25886 13.9985 8.05716 14.0385C7.85546 14.0786 7.64699 14.0683 7.45022 14.0085C7.25346 13.9487 7.07449 13.8413 6.92917 13.6958"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5625 10.9375L12.8125 10V14.0625"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HorizontalMoreIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 13.5C18.3978 13.5 18.7794 13.342 19.0607 13.0607C19.342 12.7794 19.5 12.3978 19.5 12C19.5 11.6022 19.342 11.2206 19.0607 10.9393C18.7794 10.658 18.3978 10.5 18 10.5C17.6022 10.5 17.2206 10.658 16.9393 10.9393C16.658 11.2206 16.5 11.6022 16.5 12C16.5 12.3978 16.658 12.7794 16.9393 13.0607C17.2206 13.342 17.6022 13.5 18 13.5Z"
        fill="#292C2F"
      />
      <path
        d="M13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5C11.6022 13.5 11.2206 13.342 10.9393 13.0607C10.658 12.7794 10.5 12.3978 10.5 12C10.5 11.6022 10.658 11.2206 10.9393 10.9393C11.2206 10.658 11.6022 10.5 12 10.5C12.3978 10.5 12.7794 10.658 13.0607 10.9393C13.342 11.2206 13.5 11.6022 13.5 12Z"
        fill="#292C2F"
      />
      <path
        d="M7.5 12C7.5 12.3978 7.34196 12.7794 7.06066 13.0607C6.77935 13.342 6.39782 13.5 6 13.5C5.60218 13.5 5.22065 13.342 4.93934 13.0607C4.65804 12.7794 4.5 12.3978 4.5 12C4.5 11.6022 4.65804 11.2206 4.93934 10.9393C5.22065 10.658 5.60218 10.5 6 10.5C6.39782 10.5 6.77935 10.658 7.06066 10.9393C7.34196 11.2206 7.5 11.6022 7.5 12Z"
        fill="#292C2F"
      />
    </svg>
  );
};

export const NoLeadActivity = () => {
  return (
    <svg
      width="165"
      height="169"
      viewBox="0 0 165 169"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M142.914 43.0596V50.0208"
        stroke="#003022"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M139.922 46.5322H145.904"
        stroke="#003022"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.2715 16.1997V23.1448"
        stroke="#003022"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.2656 19.6724H23.2614"
        stroke="#003022"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M66.8184 3.16566C67.5713 3.16566 68.1817 2.45701 68.1817 1.58283C68.1817 0.708657 67.5713 0 66.8184 0C66.0655 0 65.4551 0.708657 65.4551 1.58283C65.4551 2.45701 66.0655 3.16566 66.8184 3.16566Z"
        fill="#DAE8DA"
      />
      <path
        d="M110.528 66.0912C98.8841 66.0912 87.0315 65.5421 75.9441 61.9565C65.0654 58.4516 55.077 51.6519 46.1737 43.7862C40.3448 38.6662 35.0445 34.5961 27.4767 35.2098C20.0668 35.6808 12.9844 38.9088 7.27735 44.4161C-2.34935 54.1069 -0.902563 72.2449 2.9509 84.9883C8.73805 104.176 26.3499 117.469 41.3186 126.158C58.6105 136.188 77.6135 142.003 96.6582 145.362C113.352 148.302 134.803 150.45 149.271 137.787C162.557 126.158 166.201 99.6053 162.946 81.6773C162.157 76.3762 159.728 71.592 156.116 68.2232C146.781 60.309 132.856 65.5905 122.367 65.8651C118.471 65.962 114.507 66.075 110.528 66.0912Z"
        fill="#DAE8DA"
      />
      <path
        d="M82.0376 168.917C110.242 168.917 133.106 167.261 133.106 165.218C133.106 163.175 110.242 161.52 82.0376 161.52C53.833 161.52 30.9688 163.175 30.9688 165.218C30.9688 167.261 53.833 168.917 82.0376 168.917Z"
        fill="#DAE8DA"
      />
      <path
        d="M103.73 5.3642L35.7377 16.0373C33.5602 16.3791 32.0336 18.7057 32.328 21.2339L45.5135 134.458C45.8079 136.986 47.8118 138.759 49.9894 138.417L117.982 127.744C120.159 127.402 121.686 125.076 121.392 122.547L108.206 9.32291C107.912 6.79475 105.908 5.02238 103.73 5.3642Z"
        fill="#003022"
      />
      <path
        d="M126.318 21.9819H57.7072C55.5098 21.9819 53.7285 24.0501 53.7285 26.6012V140.856C53.7285 143.407 55.5098 145.475 57.7072 145.475H126.318C128.516 145.475 130.297 143.407 130.297 140.856V26.6012C130.297 24.0501 128.516 21.9819 126.318 21.9819Z"
        fill="white"
        stroke="#003022"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M108.497 110.685H75.5132C74.2762 110.685 73.2734 111.849 73.2734 113.285V113.302C73.2734 114.738 74.2762 115.902 75.5132 115.902H108.497C109.734 115.902 110.737 114.738 110.737 113.302V113.285C110.737 111.849 109.734 110.685 108.497 110.685Z"
        fill="#003022"
      />
      <path
        d="M107.315 132.005H75.666C75.2896 132.005 74.9844 132.359 74.9844 132.796V133.039C74.9844 133.476 75.2896 133.83 75.666 133.83H107.315C107.691 133.83 107.996 133.476 107.996 133.039V132.796C107.996 132.359 107.691 132.005 107.315 132.005Z"
        fill="#003022"
      />
      <path
        d="M115.383 123.461H68.7656C68.2662 123.461 67.8613 123.931 67.8613 124.511C67.8613 125.091 68.2662 125.561 68.7656 125.561H115.383C115.882 125.561 116.287 125.091 116.287 124.511C116.287 123.931 115.882 123.461 115.383 123.461Z"
        fill="#003022"
      />
      <path
        d="M123.91 25.7451H60.1118C58.5291 25.7451 57.2461 27.2347 57.2461 29.0723V93.3062C57.2461 95.1438 58.5291 96.6334 60.1118 96.6334H123.91C125.492 96.6334 126.775 95.1438 126.775 93.3062V29.0723C126.775 27.2347 125.492 25.7451 123.91 25.7451Z"
        fill="white"
        stroke="#003022"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M100.525 76.7188C100.98 76.7062 101.42 76.5334 101.788 76.2233C102.156 75.9133 102.433 75.4806 102.584 74.9828C102.735 74.485 102.752 73.9456 102.633 73.4364C102.514 72.9272 102.264 72.4721 101.916 72.1318C99.0145 69.3414 95.3565 67.8319 91.5888 67.8703C87.8211 67.9088 84.1864 69.4926 81.3274 72.3417C80.9829 72.6809 80.7354 73.1337 80.6178 73.64C80.5002 74.1464 80.5181 74.6823 80.669 75.1765C80.82 75.6708 81.0969 76.1 81.463 76.4072C81.829 76.7144 82.2669 76.885 82.7185 76.8964L100.525 76.7188Z"
        fill="white"
        stroke="#003022"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M111.892 60.5515L103.781 55.1247L111.892 49.6816"
        stroke="#003022"
        strokeWidth="0.71"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M71.4648 60.5515L79.5752 55.1247L71.4648 49.6816"
        stroke="#003022"
        strokeWidth="0.71"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.9902 95.0024V101.964"
        stroke="#003022"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.998 98.4746H29.9939"
        stroke="#003022"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M140.383 99.9284C141.136 99.9284 141.746 99.2197 141.746 98.3455C141.746 97.4713 141.136 96.7627 140.383 96.7627C139.63 96.7627 139.02 97.4713 139.02 98.3455C139.02 99.2197 139.63 99.9284 140.383 99.9284Z"
        fill="#DAE8DA"
      />
    </svg>
  );
};

export const ProfileIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C13.5913 15 15.1174 14.3679 16.2426 13.2426C17.3679 12.1174 18 10.5913 18 9C18 7.4087 17.3679 5.88258 16.2426 4.75736C15.1174 3.63214 13.5913 3 12 3C10.4087 3 8.88258 3.63214 7.75736 4.75736C6.63214 5.88258 6 7.4087 6 9C6 10.5913 6.63214 12.1174 7.75736 13.2426C8.88258 14.3679 10.4087 15 12 15Z"
        stroke="#5B6167"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.90625 20.2498C3.82772 18.6533 5.15326 17.3274 6.74961 16.4056C8.34597 15.4838 10.1569 14.9985 12.0002 14.9985C13.8436 14.9985 15.6545 15.4838 17.2509 16.4056C18.8472 17.3274 20.1728 18.6533 21.0942 20.2498"
        stroke="#5B6167"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 5.25L12 13.5L3 5.25"
        stroke="#5B6167"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z"
        stroke="#5B6167"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3604 12L3.23438 18.534"
        stroke="#5B6167"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.7656 18.534L13.6396 12"
        stroke="#5B6167"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DownArrowIcons = ({ fill = "none", stroke = "#292D32" }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.49915 9.47559L12.2491 16.2256L18.9991 9.47559"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReviewIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H14.25L19.5 8.25V20.25C19.5 20.4489 19.421 20.6397 19.2803 20.7803C19.1397 20.921 18.9489 21 18.75 21Z"
        stroke="#283745"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.875 3V8.625H19.5" fill="#283745" />
      <path
        d="M13.875 3V8.625H19.5"
        stroke="#283745"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.625 16.125C12.2217 16.125 12.794 15.8879 13.216 15.466C13.6379 15.044 13.875 14.4717 13.875 13.875C13.875 13.2783 13.6379 12.706 13.216 12.284C12.794 11.8621 12.2217 11.625 11.625 11.625C11.0283 11.625 10.456 11.8621 10.034 12.284C9.61205 12.706 9.375 13.2783 9.375 13.875C9.375 14.4717 9.61205 15.044 10.034 15.466C10.456 15.8879 11.0283 16.125 11.625 16.125Z"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2188 15.4692L14.9808 17.2312"
        stroke="#292C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AttachmentIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6598 11.466C19.7995 11.6097 19.8769 11.8027 19.875 12.0031C19.8731 12.2035 19.7922 12.395 19.6498 12.536L11.9628 20.213C10.9782 21.1976 9.64272 21.7508 8.25027 21.7508C6.85781 21.7508 5.52238 21.1976 4.53777 20.213C3.55315 19.2284 3 17.893 3 16.5005C3 15.1081 3.55315 13.7726 4.53777 12.788L13.8468 3.35702C14.1912 2.9936 14.6048 2.70281 15.0634 2.50182C15.522 2.30083 16.0161 2.19371 16.5167 2.18676C17.0174 2.17982 17.5143 2.27319 17.9783 2.46138C18.4423 2.64958 18.8638 2.92877 19.2182 3.2825C19.5725 3.63623 19.8524 4.05734 20.0414 4.52098C20.2304 4.98462 20.3246 5.48142 20.3185 5.98206C20.3124 6.4827 20.2061 6.97705 20.0059 7.43595C19.8057 7.89486 19.5156 8.30902 19.1528 8.65402L9.84277 18.085C9.63481 18.2963 9.38683 18.464 9.11331 18.5784C8.83979 18.6927 8.54623 18.7514 8.24977 18.751C7.80388 18.7522 7.3677 18.6209 6.99658 18.3738C6.62546 18.1266 6.33614 17.7748 6.16534 17.3629C5.99455 16.951 5.94998 16.4977 6.0373 16.0604C6.12462 15.6232 6.33988 15.2217 6.65577 14.907L14.4658 6.97602C14.5331 6.89946 14.6154 6.83744 14.7076 6.79375C14.7997 6.75006 14.8998 6.72563 15.0017 6.72195C15.1036 6.71826 15.2052 6.7354 15.3003 6.77231C15.3954 6.80923 15.4819 6.86514 15.5546 6.93664C15.6274 7.00813 15.6847 7.09371 15.7233 7.18814C15.7618 7.28257 15.7807 7.38386 15.7787 7.48582C15.7767 7.58779 15.754 7.68828 15.7119 7.78116C15.6698 7.87404 15.6092 7.95736 15.5338 8.02602L7.72477 15.966C7.6536 16.0358 7.59705 16.119 7.55842 16.2109C7.51979 16.3027 7.49985 16.4014 7.49977 16.501C7.50293 16.6483 7.54885 16.7916 7.63194 16.9133C7.71502 17.0349 7.8317 17.1299 7.96775 17.1864C8.10381 17.243 8.25338 17.2588 8.39825 17.232C8.54313 17.2051 8.67707 17.1367 8.78377 17.035L18.0838 7.59502C18.2953 7.38683 18.4631 7.13852 18.5775 6.86464C18.6919 6.59076 18.7504 6.29682 18.7498 6.00002C18.751 5.55414 18.6197 5.11795 18.3725 4.74683C18.1254 4.37571 17.7735 4.08639 17.3616 3.9156C16.9497 3.7448 16.4964 3.70023 16.0592 3.78755C15.6219 3.87487 15.2205 4.09013 14.9058 4.40602L5.60577 13.846C5.24456 14.1909 4.95588 14.6045 4.75669 15.0625C4.5575 15.5205 4.4518 16.0137 4.44581 16.5131C4.43981 17.0125 4.53363 17.5081 4.72177 17.9707C4.90991 18.4334 5.18856 18.8538 5.54139 19.2073C5.89421 19.5608 6.31409 19.8402 6.77639 20.0292C7.23868 20.2182 7.73408 20.313 8.23349 20.3079C8.73291 20.3029 9.22628 20.1981 9.68466 19.9998C10.143 19.8015 10.5572 19.5136 10.9028 19.153L18.5908 11.465C18.733 11.3246 18.9249 11.2458 19.1248 11.2458C19.3247 11.2458 19.5165 11.3246 19.6588 11.465L19.6598 11.466Z"
        fill="black"
      />
    </svg>
  );
};

export const FileIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H14.25L19.5 8.25V20.25C19.5 20.4489 19.421 20.6397 19.2803 20.7803C19.1397 20.921 18.9489 21 18.75 21Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.875 3V8.625H19.5"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BirthDatePickerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 2.99999H18.75V2.27109C18.75 1.86749 18.4397 1.52109 18.0361 1.50093C17.9347 1.49604 17.8333 1.5118 17.7382 1.54724C17.6431 1.58267 17.5561 1.63706 17.4826 1.7071C17.4091 1.77713 17.3506 1.86136 17.3106 1.95468C17.2706 2.048 17.25 2.14847 17.25 2.24999V2.99999H6.75V2.27109C6.75 1.86749 6.43969 1.52109 6.03609 1.50093C5.93469 1.49604 5.83334 1.5118 5.7382 1.54724C5.64307 1.58267 5.55611 1.63706 5.48261 1.7071C5.40911 1.77713 5.3506 1.86136 5.31062 1.95468C5.27063 2.048 5.25001 2.14847 5.25 2.24999V2.99999H4.5C3.70435 2.99999 2.94129 3.31606 2.37868 3.87867C1.81607 4.44128 1.5 5.20435 1.5 6V6.5625C1.5 6.61222 1.51975 6.65992 1.55492 6.69508C1.59008 6.73024 1.63777 6.75 1.6875 6.75H22.3125C22.3622 6.75 22.4099 6.73024 22.4451 6.69508C22.4802 6.65992 22.5 6.61222 22.5 6.5625V6C22.5 5.20435 22.1839 4.44128 21.6213 3.87867C21.0587 3.31606 20.2956 2.99999 19.5 2.99999Z"
        fill="#031226"
      />
      <path
        d="M22.3125 8.25H1.6875C1.63777 8.25 1.59008 8.26975 1.55492 8.30492C1.51975 8.34008 1.5 8.38777 1.5 8.4375V19.5C1.5 20.2956 1.81607 21.0587 2.37868 21.6213C2.94129 22.1839 3.70435 22.5 4.5 22.5H19.5C20.2956 22.5 21.0587 22.1839 21.6213 21.6213C22.1839 21.0587 22.5 20.2956 22.5 19.5V8.4375C22.5 8.38777 22.4802 8.34008 22.4451 8.30492C22.4099 8.26975 22.3622 8.25 22.3125 8.25ZM11.2303 18.8016C10.6598 19.252 9.88266 19.5 9.04125 19.5C7.73484 19.5 6.76875 18.6487 6.33844 17.9203C6.23712 17.749 6.208 17.5445 6.25749 17.3517C6.30698 17.1589 6.43103 16.9937 6.60234 16.8923C6.77366 16.791 6.9782 16.7619 7.17099 16.8114C7.36377 16.8609 7.52899 16.9849 7.63031 17.1562C7.68094 17.2425 8.15297 18 9.04125 18C9.82219 18 10.7344 17.6583 10.7344 16.6959C10.7344 16.403 10.6772 15.9952 10.4062 15.7172C10.0059 15.3075 9.33984 15.1233 8.99484 15.1233C8.79593 15.1233 8.60517 15.0443 8.46451 14.9036C8.32386 14.763 8.24484 14.5722 8.24484 14.3733C8.24484 14.1744 8.32386 13.9836 8.46451 13.843C8.60517 13.7023 8.79593 13.6233 8.99484 13.6233C9.22219 13.6233 9.81094 13.5014 10.1798 13.1241C10.2796 13.0259 10.3584 12.9085 10.4114 12.7789C10.4643 12.6493 10.4903 12.5103 10.4878 12.3703C10.4878 11.2814 9.14578 11.25 8.99297 11.25C8.18016 11.25 7.87734 11.7473 7.86469 11.7684C7.81596 11.8558 7.75025 11.9325 7.67142 11.9941C7.5926 12.0557 7.50225 12.1009 7.40569 12.127C7.30914 12.1532 7.20833 12.1597 7.1092 12.1463C7.01007 12.1329 6.91462 12.0998 6.82847 12.049C6.74233 11.9982 6.66722 11.9306 6.60758 11.8503C6.54794 11.77 6.50496 11.6786 6.48118 11.5814C6.4574 11.4842 6.4533 11.3833 6.46912 11.2845C6.48493 11.1857 6.52035 11.0911 6.57328 11.0063C6.93141 10.3969 7.75547 9.75 8.99297 9.75C9.76359 9.75 10.4817 9.97359 11.0147 10.3791C11.6423 10.8572 11.9878 11.5641 11.9878 12.3703C11.9899 12.7046 11.9258 13.0359 11.7992 13.3453C11.6725 13.6546 11.4859 13.9358 11.25 14.1727C11.1961 14.228 11.1394 14.2795 11.0817 14.3297C11.2225 14.4314 11.3546 14.5448 11.4764 14.6686C11.9714 15.1748 12.233 15.8756 12.233 16.6959C12.2344 17.5425 11.8777 18.2902 11.2303 18.8016ZM17.25 18.5625C17.25 18.7614 17.171 18.9522 17.0303 19.0928C16.8897 19.2335 16.6989 19.3125 16.5 19.3125C16.3011 19.3125 16.1103 19.2335 15.9697 19.0928C15.829 18.9522 15.75 18.7614 15.75 18.5625V12.0136L14.6948 12.7913C14.6156 12.8497 14.5255 12.892 14.4299 12.9157C14.3343 12.9394 14.2349 12.944 14.1375 12.9293C14.0401 12.9146 13.9465 12.8808 13.8622 12.83C13.7778 12.7791 13.7043 12.7121 13.6458 12.6328C13.5873 12.5535 13.545 12.4635 13.5213 12.3679C13.4976 12.2722 13.493 12.1729 13.5077 12.0755C13.5224 11.9781 13.5562 11.8845 13.6071 11.8001C13.6579 11.7158 13.7249 11.6422 13.8042 11.5837L15.8395 10.0837C15.9684 9.98877 16.1243 9.93752 16.2844 9.9375H16.5C16.6989 9.9375 16.8897 10.0165 17.0303 10.1572C17.171 10.2978 17.25 10.4886 17.25 10.6875V18.5625Z"
        fill="#031226"
      />
    </svg>
  );
};
export const MinusIcon = ({ width = "24", height = "24", fill = "none", stroke = "currentColor" }) => {
    return (
		<svg width={width} height={height} fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path d="M3.75 12h16.5"></path>
		</svg>
    )
}

export const RightIcon = ()=> {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.25 6.75L9.75 17.25L4.5 12" stroke="#D0F5D0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export const CloseIcon = () =>{
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.75 5.25L5.25 18.75" stroke="#FFECF2" stroke-opacity="0.996078" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.75 18.75L5.25 5.25" stroke="#FFECF2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
    // return(
	// 	<svg width={width} height={height} fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	// 		<path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"></path>
	// 		<path d="M3.516 9h16.968"></path>
	// 		<path d="M3.516 15h16.968"></path>
	// 		<path d="M12 20.755c2.071 0 3.75-3.92 3.75-8.757 0-4.836-1.679-8.756-3.75-8.756-2.071 0-3.75 3.92-3.75 8.756s1.679 8.757 3.75 8.757Z"></path>
	// 	</svg>
}

export const MEdit = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.2333 4.90008L11.1 2.76674L11.8 2.06674C11.9889 1.87785 12.225 1.78619 12.5083 1.79174C12.7917 1.7973 13.0278 1.89452 13.2167 2.08341L13.9333 2.80008C14.1222 2.98896 14.2167 3.2223 14.2167 3.50008C14.2167 3.77785 14.1222 4.01119 13.9333 4.20008L13.2333 4.90008ZM12.5333 5.60007L4.13333 14.0001H2V11.8667L10.4 3.46674L12.5333 5.60007Z" fill="black"/>
        </svg>
    )
}

export const ArrowLeft = ({stroke="rgba(18,18,18,0.62)", width="18.5", height="14.261"}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
            <g id="Group_54991" data-name="Group 54991" transform="translate(-686.75 -192.869)">
                <path id="Vector" d="M6.07,0,0,6.07l6.07,6.07" transform="translate(687.5 193.93)" fill="none" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <path id="Vector-2" data-name="Vector" d="M16.83,0H0" transform="translate(687.67 200)" fill="none" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
            </g>
        </svg>
    )
}


export const EditProfile2= ({fill = '#7b7f82'}) => {
    return (
        <svg id="Component_189_1" data-name="Component 189 – 1" xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31">
            <g id="Rectangle_26836" data-name="Rectangle 26836" fill="#f4f7fc" stroke="#f4f7fc" strokeWidth="0.5">
                <rect width="31" height="31" rx="8" stroke="none"/>
                <rect x="0.25" y="0.25" width="30.5" height="30.5" rx="7.75" fill="none"/>
            </g>
            <g id="vuesax_bold_edit" data-name="vuesax/bold/edit" transform="translate(4 4)">
                <g id="edit">
                <path id="Vector" d="M13.48,0H5.519C2.061,0,0,2.17,0,5.81v8.37C0,17.83,2.061,20,5.519,20h7.951c3.458,0,5.519-2.17,5.519-5.81V5.81C19,2.17,16.938,0,13.48,0ZM8.5,15.51a2.407,2.407,0,0,1-1.178.63l-2.337.35a2.215,2.215,0,0,1-.256.02,1.369,1.369,0,0,1-1.007-.41,1.58,1.58,0,0,1-.37-1.34l.332-2.46a2.5,2.5,0,0,1,.6-1.24L8.521,6.6c.076.21.152.42.256.66.095.21.2.43.313.63a5.032,5.032,0,0,0,.285.45,3.714,3.714,0,0,0,.3.42,1.354,1.354,0,0,0,.1.14,6.384,6.384,0,0,0,.75.79.889.889,0,0,0,.123.12c.142.12.285.24.408.33a3.538,3.538,0,0,0,.465.32c.19.12.4.23.608.34s.418.19.617.26Zm6.1-6.42-.874.93a.287.287,0,0,1-.209.09.225.225,0,0,1-.085-.01A6.055,6.055,0,0,1,9.414,5.87a.308.308,0,0,1,.076-.3l.883-.93c1.444-1.52,2.821-1.49,4.237,0a3.276,3.276,0,0,1,1.073,2.25A3.307,3.307,0,0,1,14.6,9.09Z" transform="translate(2 2)" fill={fill}/>
                <path id="Vector-2" data-name="Vector" d="M0,0H23V24H0Z" transform="translate(23 24) rotate(180)" fill="none" opacity="0"/>
                </g>
            </g>
        </svg>
    )
}

export const MCamera = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.0138 3.98797C13.7634 3.98671 13.5181 3.91701 13.3045 3.7864C13.0909 3.6558 12.917 3.46926 12.8018 3.24697L12.2018 2.03597C11.9739 1.63575 11.6495 1.29897 11.258 1.05634C10.8666 0.813718 10.4206 0.672981 9.96079 0.646973L8.04679 0.646973C7.58618 0.671972 7.13918 0.81202 6.74665 1.05432C6.35413 1.29661 6.02859 1.63343 5.79979 2.03397L5.19879 3.24697C5.08381 3.46963 4.91008 3.65658 4.69644 3.78755C4.48279 3.91852 4.23738 3.98852 3.98679 3.98997C3.55824 3.98941 3.13412 4.07671 2.74064 4.2465C2.34715 4.41628 1.99266 4.66493 1.69905 4.9771C1.40543 5.28927 1.17894 5.65832 1.03356 6.06146C0.88818 6.4646 0.826996 6.89326 0.85379 7.32097L1.28779 14.221C1.27147 14.6542 1.3482 15.0858 1.5128 15.4868C1.6774 15.8879 1.92605 16.2489 2.242 16.5457C2.55794 16.8425 2.93384 17.0682 3.34436 17.2074C3.75487 17.3467 4.19047 17.3963 4.62179 17.353H13.3788C13.8099 17.3955 14.2452 17.3452 14.6553 17.2057C15.0655 17.0661 15.441 16.8405 15.7568 16.5438C16.0726 16.2472 16.3212 15.8865 16.4861 15.4858C16.651 15.0852 16.7283 14.6539 16.7128 14.221L17.1468 7.32097C17.1739 6.8931 17.1129 6.46422 16.9676 6.06084C16.8224 5.65747 16.5959 5.28817 16.3023 4.97578C16.0087 4.6634 15.6541 4.41456 15.2604 4.24466C14.8668 4.07475 14.4425 3.98739 14.0138 3.98797ZM7.74679 5.03197H10.2538C10.4199 5.03197 10.5793 5.09798 10.6968 5.21547C10.8143 5.33296 10.8803 5.49231 10.8803 5.65847C10.8803 5.82463 10.8143 5.98398 10.6968 6.10148C10.5793 6.21897 10.4199 6.28497 10.2538 6.28497H7.74679C7.58063 6.28497 7.42128 6.21897 7.30379 6.10148C7.1863 5.98398 7.12029 5.82463 7.12029 5.65847C7.12029 5.49231 7.1863 5.33296 7.30379 5.21547C7.42128 5.09798 7.58063 5.03197 7.74679 5.03197ZM8.99979 14.111C8.4415 14.1108 7.8958 13.945 7.43169 13.6347C6.96758 13.3244 6.6059 12.8834 6.39239 12.3676C6.17888 11.8517 6.12312 11.2842 6.23215 10.7366C6.34119 10.1891 6.61014 9.68616 7.00498 9.29146C7.39982 8.89675 7.90284 8.62799 8.45042 8.51914C8.998 8.4103 9.56556 8.46626 10.0813 8.67996C10.5971 8.89365 11.0379 9.25548 11.3481 9.7197C11.6582 10.1839 11.8238 10.7297 11.8238 11.288C11.823 12.0366 11.5252 12.7543 10.9957 13.2836C10.4663 13.8129 9.74843 14.1104 8.99979 14.111Z" fill="#333333"/>
        </svg>
    )
}

export const StoreIcon = ({ width = '24', height = '24', fill = 'none', stroke = "currentColor" }) => {
    return(
		<svg width={width} height={height} fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path d="M4.5 13.086v6.412a.75.75 0 0 0 .75.75h13.5a.75.75 0 0 0 .75-.75v-6.412"></path>
			<path d="M5.063 3.75h13.875a.76.76 0 0 1 .721.544L21 9H3l1.34-4.706a.76.76 0 0 1 .723-.544v0Z"></path>
			<path d="M9 9v1.5a3 3 0 0 1-6 0V9"></path>
			<path d="M15 9v1.5a3 3 0 0 1-6 0V9"></path>
			<path d="M21 9v1.5a3 3 0 0 1-6 0V9"></path>
		</svg>
    )
}

export const CartIcon = ({ width = '24', height = '24', fill = 'none', stroke = "currentColor" }) => {
    return(
		<svg width={width} height={height} fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path fill={stroke} stroke="none" d="M7.5 22.125a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"></path>
			<path fill={stroke} stroke="none" d="M17.25 22.125a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"></path>
			<path d="M3.966 6.75h16.818l-2.259 7.912a1.5 1.5 0 0 1-1.444 1.088H7.67a1.5 1.5 0 0 1-1.444-1.088L3.047 3.544A.75.75 0 0 0 2.325 3h-1.2"></path>
		</svg>
    )
}

export const ReceiptIcon = ({ width = '24', height = '24', fill = 'none', stroke = "currentColor" }) => {
    return(
		<svg width={width} height={height} fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path d="M7.125 9.375h9.75"></path>
			<path d="M7.125 13.125h9.75"></path>
			<path d="M3 19.5V5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 .75.75V19.5L18 18l-3 1.5-3-1.5-3 1.5L6 18l-3 1.5Z"></path>
		</svg>
    )
}

export const UserIcon = ({ width = '24', height = '24', fill = 'none' }) => {
    return(
		<svg width={width} height={height} fill={fill} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path d="M12 15.375a4.125 4.125 0 1 0 0-8.25 4.125 4.125 0 0 0 0 8.25Z"></path>
			<path d="M12 2.25A9.75 9.75 0 1 0 21.75 12 9.769 9.769 0 0 0 12 2.25Zm6.169 15.225a7.624 7.624 0 0 0-2.297-2.156 5.597 5.597 0 0 1-7.744 0 7.622 7.622 0 0 0-2.297 2.156 8.25 8.25 0 1 1 12.338 0Z"></path>
		</svg>
    )
}

export const TrashIcon = ({ width = '24', height = '24', fill = 'none', stroke = "currentColor" }) => {
    return(
		<svg width={width} height={height} fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path d="M20.25 5.625H3.75"></path>
			<path d="M9.75 9.75v6"></path>
			<path d="M14.25 9.75v6"></path>
			<path d="M18.75 5.625V19.5a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V5.625"></path>
			<path d="M15.75 5.625v-2.25a1.5 1.5 0 0 0-1.5-1.5h-4.5a1.5 1.5 0 0 0-1.5 1.5v2.25"></path>
		</svg>
    )
}